/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/backoffice/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Index endpoint for all accounts */
        post: operations["backoffice.account.index"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/accounts/{account}/closed-loop/toggle": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.account.closed-loop.toggle"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/accounts/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.account.show"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/accounts/block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint to block payment accounts from being used */
        post: operations["backoffice.account.block"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/approval/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.approval.approve"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/approval/deny": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.approval.deny"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/approval/users/{userId}/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns detailed information about a users, for use when approving withdrawals */
        post: operations["backoffice.approval.user-details"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/approval/withdrawals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns a list of all the withdrawals which require manual approval */
        post: operations["backoffice.approval.withdrawals"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/credorax/get-arn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["modules.backoffice.credorax.getArn_142"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/dynamic-configs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Index endpoint of all config classes */
        post: operations["backoffice.dynamic-config.index"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/dynamic-configs/{namespace}/structure": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the structure of a single config */
        post: operations["backoffice.dynamic-config.structure"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/dynamic-configs/{namespace}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Updates the dynamic config values */
        post: operations["backoffice.dynamic-config.update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/dynamic-configs/import-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the dynamic config import config */
        post: operations["backoffice.dynamic-config.import-config"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/dynamic-configs/reset-and-implement-config/{configType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Deletes all data from the `configs` table */
        post: operations["backoffice.dynamic-config.reset-and-implement-config"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargeback-cases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List chargeback cases: one row per player with at least one attributable chargeback or
         *     active repayment
         * @description Balance = sum(chargeback amount + fees) - sum(active repayments); all chargebacks count,
         *     including reimbursed ones. Chargebacks without a deposit/account cannot be attributed to a
         *     player and are excluded - their count is exposed as unattributed_chargeback_count.
         */
        get: operations["platform.chargeback-cases.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargeback-cases/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a player's full chargeback case: stats plus the chargeback and repayment lists
         * @description 404 only for unknown players; a known player with zero chargebacks is a valid, empty case.
         */
        get: operations["platform.chargeback-cases.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargeback-cases/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.chargeback-cases.export"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargeback-repayments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record a repayment a player made to our bank account
         * @description created_by is the acting employee taken from the remote-user header - never a body field.
         */
        post: operations["platform.chargeback-repayments.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargeback-repayments/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Soft-delete a repayment, hiding it everywhere and excluding it from balances
         * @description deleted_by is the acting employee taken from the remote-user header. An already-deleted or
         *     unknown id yields a 404.
         */
        delete: operations["platform.chargeback-repayments.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargebacks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Fetch chargebacks from database with pagination and search filters
         * @description Filterable via filters[<name>]; call platform.chargebacks.search-parameters for the list and
         *     each parameter's type/nullability. user_id also accepts a customer number (e.g. SN1234012).
         *     Each data item is a ChargebackData carrying the user_id derived through the deposit's account
         *     (null when the chargeback has no linked deposit).
         */
        get: operations["platform.chargebacks.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargebacks/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a specific chargeback by ID
         * @description The response includes the derived nullable user_id and the event log.
         */
        get: operations["platform.chargebacks.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/chargebacks/search-parameters": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get available search parameters for chargebacks
         * @description Each entry reports a parameter's name, type, options and whether it is nullable.
         */
        get: operations["platform.chargebacks.search-parameters"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/credorax/chargebacks/fetch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Fetch and save Credorax chargebacks to database
         *     This will be triggered via a cron job
         */
        get: operations["platform.credorax.chargebacks.fetch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.documents.list"];
        put?: never;
        post: operations["platform.documents.upload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/documents/{key}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["platform.documents.delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/documents/{key}/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.documents.download"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/reconciliations/unreconciled": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.reconciliations.unreconciled"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/settlement-adjustments/monthly": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.settlement-adjustments.monthly"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/settlement-summaries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.settlement-summaries.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/finance-automation/settlement-summaries/recalculate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["platform.settlement-summaries.recalculate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/top-lists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Index endpoint for all top lists */
        post: operations["backoffice.top-list.index"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/top-lists/search-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Get search options */
        post: operations["backoffice.top-list.search-options"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Index endpoint for all transactions (deposits/withdrawals/refunds) */
        post: operations["backoffice.transaction.index"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/{transactionType}/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.transaction.show"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/{transactionType}/{id}/payment-information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.transaction.payment-information"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/allowed-states": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the allowed states for the given transaction type */
        post: operations["backoffice.transaction.allowed-states"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/force-state": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Forces a state change for a given transaction */
        post: operations["backoffice.transaction.force-state"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/mass-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Mass updates state of transactions */
        post: operations["backoffice.transaction.mass-update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/sum": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.transaction.sumTransactions"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/transactions/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.transaction.summary"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/users/{userIdentifier}/closed-loop-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backoffice.users.closed-loop-info"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/withdrawals/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancels a list of withdrawals on behalf of an operator, reusing the existing user-path
         *     cancel flow (guards + PSP notification + funds refund + state transition)
         */
        post: operations["backoffice.withdrawal.cancel"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/withdrawals/revert": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reverts a list of withdrawals via their PSP
         * @description Per-id success is reported in the response; the PSP-side revert flow asynchronously
         *     pushes the resulting REJECTED state back through the existing reject upstream endpoint.
         */
        post: operations["backoffice.withdrawal.revert"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/import/dynamic-config/receive": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** API endpoint to receive dynamic configs */
        post: operations["import.dynamic-config"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/accounts/{account}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Callback endpoint for updating data related to an account */
        post: operations["integration.account.update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/{deposit}/finalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Finalizes a deposit transaction */
        post: operations["integration.deposit.finalize"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/{deposit}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Cancels a deposit */
        post: operations["integration.deposit.reject"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/{deposit}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Async callback endpoint for updating data related to a deposit */
        post: operations["integration.deposit.update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/authorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a new deposit and authorizes the deposit if possible */
        post: operations["integration.deposit.authorize"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a quick deposit at the PSP */
        post: operations["payment-service.create-deposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/create-first": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a first deposit at the PSP */
        post: operations["payment-service.create-first-deposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/deposit-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the available deposit options for the user */
        post: operations["payment-service.deposit.get-options"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/deposits/update-kyc-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * This is used to capture or void a transaction based on KYC response
         *     This is only used if capture is set to MANUAL
         */
        post: operations["payment-service.deposit.update-kyc-status"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/fraud/user/{userId}/analysis/sca/{PSP}/{paymentMethod}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the SCA analysis for the specified user.
         *     The analysis defines our expectations about forcing SCA checks
         */
        get: operations["integration.fraud.analysis.sca"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/get-arn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Fetches the ARN for a given transaction */
        post: operations["paymentServiceControllerContract.getArn"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/payment-information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Fetches all payment information held by the PSP for a given transaction */
        post: operations["payment-service.get-payment-information"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/refunds/{refund}/authorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a new refund and authorizes the refund if possible */
        post: operations["integration.refund.authorize"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/refunds/{refund}/finalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Finalizes a deposit transaction */
        post: operations["integration.refund.finalize"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/refunds/{refund}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Cancels a deposit */
        post: operations["integration.refund.reject"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/refunds/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a refund at the PSP */
        post: operations["payment-service.create-refund"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/users/{userId}/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint that returns information about whether a user can pass verification check */
        post: operations["integration.user.verify"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/{withdrawal}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the withdrawal resource */
        get: operations["integration.withdraw.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/{withdrawal}/finalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Finalizes a withdrawal transaction */
        post: operations["integration.withdraw.finalize"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/{withdrawal}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Rejects a withdrawal transaction */
        post: operations["integration.withdraw.reject"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/{withdrawal}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Updates the withdrawal resource */
        post: operations["integration.withdraw.update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/approved": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for approving a withdrawal */
        post: operations["payment-service.approve-withdrawal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for cancelling withdrawals */
        post: operations["payment-service.cancel-withdrawal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/cancel-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the cancel status of a list of withdrawals */
        post: operations["payment-service.withdrawals.cancel-status"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/create/cit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a withdrawal at the PSP initiated by a customer */
        post: operations["payment-service.create-withdrawal.cit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/create/cit-open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a withdrawal in PaymentIQ */
        post: operations["payment-service.create-withdrawal.cit-open-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/create/mit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a withdrawal at the PSP initiated by the merchant (us) */
        post: operations["payment-service.create-withdrawal.mit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/create/mit-open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a withdrawal at the PSP initiated by the merchant (us) */
        post: operations["payment-service.create-withdrawal.mit-open-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/denied": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for denying a withdrawal */
        post: operations["payment-service.deny-withdrawal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/withdrawals/revert": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for reverting finalized withdrawals (operator-driven) */
        post: operations["payment-service.revert-withdrawal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/accounts/{account}/block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint to block payment account from being used */
        post: operations["case-management.block-account"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/accounts/{account}/toggle-closed-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["case-management.toggle-closed-loop-for-account"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/accounts/block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint to block payment accounts from being used */
        post: operations["case-management.block-accounts"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/combined-accounts-overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get combined account overview of a player */
        get: operations["case-management.combined-accounts-overview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/deposit-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get deposit statistics for successful and failed deposits */
        get: operations["case-management.deposit-stats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/payments-overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get payment overview of a user */
        get: operations["case-management.payments-overview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/player-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get transactions made from and to a player */
        get: operations["case-management.transactionsByPlayer"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get all transactions for an account */
        get: operations["case-management.transactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/case-management/transactions-overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used to get all successful deposits within intervals for a player id */
        get: operations["case-management.transactions-overview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/deposits/{deposit}/refund": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a refund for deposit */
        post: operations["platform.deposits.refund"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/manual-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a manual transaction */
        post: operations["platform.manual-transaction.create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/money-limits/progress/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the deposit limit progress of the given player id */
        get: operations["platform.money-limits.deposit-limit-progress"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/accounts/{account}/hide": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint used by platform BO for setting the visibility of the account to false */
        post: operations["platform.monolith-backoffice.accounts.hide"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/accounts/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting the accounts for a specific user */
        get: operations["platform.monolith-backoffice.accounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/accounts/{userId}/mit-withdrawable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting MIT withdrawable accounts for a specific user */
        get: operations["platform.monolith-backoffice.mit-withdrawable-accounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/payment-details/{uuid}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting details about a 'payment', i.e. deposit or refund */
        get: operations["platform.monolith-backoffice.payment-details"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/payments/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting the 'payments', i.e. deposits and refunds */
        get: operations["platform.monolith-backoffice.payments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/monolith-backoffice/payouts/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting the 'Payouts', i.e. withdrawals */
        get: operations["platform.monolith-backoffice.payouts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/accounts/accounts-used-count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.accounts.players.accounts-used-count"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/accounts/established": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.accounts.players.established"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/accounts/has-recent-success-with-different-method": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.accounts.players.has-recent-success-with-different-method"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/accounts/recent-success": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.accounts.players.recent-success"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposit-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.player.deposit-stats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/active-amount-since": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the sum of a player's deposits in AUTHORIZED or FINALIZED state within an optional date range */
        get: operations["platform.deposits.players.active-amount-since"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/finalized-amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the sum of a player's finalized deposits within an optional date range */
        get: operations["platform.deposits.players.finalized-amount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/has-finalized": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Checks whether a player has any finalized deposits within an optional date range */
        get: operations["platform.deposits.players.has-finalized"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/has-since": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Checks whether a player has any deposit (in any state) within an optional date range */
        get: operations["platform.deposits.players.has-since"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/max-amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the maximum deposit amount for a player within an optional date range */
        get: operations["platform.deposits.players.max-amount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/deposits/payment-method-amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the sum of a player's deposits filtered by payment method within an optional date range */
        get: operations["platform.deposits.players.payment-method-amount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/manual-transactions/amount-for-type": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the summed amount of **positive** manual transactions of the given type for the given
         *     users via. the playerId, within an optional created_at date range. Zero/negative entries (e.g. corrections) are
         *     excluded
         */
        get: operations["platform.manual-transactions.players.amount-for-type"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/withdrawals/has-since": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.withdrawals.players.has-since"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/player/{playerId}/withdrawals/manually-approved": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint to get manually approved withdrawal data */
        get: operations["case-management.players.manually-approved-withdrawals"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/raventrack/metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns the metrics required for the RavenTrack integration */
        post: operations["platform.raven-track.metrics"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/accounts/{account}/hide": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint used by platform BO for setting the visibility of the account to false
         * @description 🔒 **Required role:** `payments-write`
         */
        post: operations["platform.support-backoffice.accounts.hide"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/deposits/{deposit}/refund": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Creates a refund for deposit
         * @description 🔒 **Required role:** `payments-write`
         */
        post: operations["platform.support-backoffice.deposits.refund"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/transaction/get-arn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `payments-write` */
        post: operations["platform.support-backoffice.transaction.get-arn"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/transactions/{uuid}/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by the support backoffice for getting the details of a single transaction, i.e. a deposit, refund or withdrawal,
         *     with its account and state logs attached
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.transactions.details"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/user/{userId}/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by platform BO for getting the accounts for a specific user
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.user.accounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/user/{userId}/accounts/mit-withdrawable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by platform BO for getting MIT withdrawable accounts for a specific user
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.user.accounts.mit-withdrawable"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/user/{userId}/deposits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by platform BO for getting the 'payments', i.e. deposits and refunds
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.user.deposits"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/user/{userId}/manual-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by platform BO for getting manual transactions for a user
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.user.manual-transactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/user/{userId}/withdrawals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint used by the support backoffice for getting the withdrawals of a user
         * @description 🔒 **Required role:** `payments-read`
         */
        get: operations["platform.support-backoffice.user.withdrawals"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/withdrawals/closed-loop/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Initiates a MIT withdrawal on an existing account
         * @description 🔒 **Required role:** `withdrawals-create`
         */
        post: operations["platform.support-backoffice.withdrawals.closed-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/support-backoffice/withdrawals/open-loop/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Initiates a MIT withdrawal on a new account
         * @description 🔒 **Required role:** `withdrawals-create`
         */
        post: operations["platform.support-backoffice.withdrawals.open-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/accounts/established": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.user.accounts.established"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/deposits/finalized": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns all finalized deposits for a given user, ordered by created_at descending */
        get: operations["platform.user.deposits.finalized"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/deposits/has-user-made-a-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.user.deposits.has-user-made-a-deposit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/deposits/last-successful-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.user.deposits.last-successful-deposit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/deposits/last-successful-time": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.user.deposits.last-successful-time"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/manual-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint used by platform BO for getting manual transactions for a user */
        get: operations["platform.user.manual-transactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/user/{userId}/withdrawals/finalized": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.user.withdrawals.finalized"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/users/deposits/first-depositing-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["platform.users.deposits.first-depositing-users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/users/deposits/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint used to get stats for a list of users */
        post: operations["platform.users.deposits.index"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/users/deposits/successful-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint used to find stats for the successful deposits for a list of users */
        post: operations["platform.users.deposits.successful-users"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Initiates a MIT withdrawal on an existing account */
        post: operations["platform.withdrawals.create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/attempt-automatic": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Attempts an automatic withdrawal for a given user and a specific amount.
         *     This is at-most an attempt, and has NO guarantees that it will actually happen
         */
        post: operations["platform.withdrawals.attempt-automatic"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/find-by-ids": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["platform.monolith.withdrawals.find-by-ids"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/minimum-withdrawable-amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint for minimum possible fee, this is meant to be used in MIT context, and we can therefore ignore open loop */
        get: operations["platform.withdrawals.minimum-withdrawable-amount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/non-failed-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["platform.monolith.withdrawals.non-failed-stats"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Initiates a MIT withdrawal on a new account */
        post: operations["platform.withdrawals.open-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/platform/withdrawals/stuck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["platform.withdrawals.stuck"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/{paymentMethod}/certificate/{brand}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["public.certificate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/account/{account}/disable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Disables the given account or the accounts with same payment method, so it no longer shows up in the active account list */
        post: operations["public.account.account.disable"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Initiates a quick deposit */
        post: operations["public.cashier.deposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns all available deposit accounts for the user */
        get: operations["public.cashier.deposit.accounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/calculate-fee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Calculates the fee for a given account and amount */
        get: operations["public.cashier.deposit.calculate-fee"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/configs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the deposit config to use in the frontend */
        get: operations["public.cashier.deposit.configs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/deposit-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["public.cashier.deposit.options"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/failed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Stores a deposit attempt that failed in the cashier as a rejected deposit */
        post: operations["public.cashier.deposit.failed"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/first-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Initiates first deposit */
        post: operations["public.cashier.first-deposit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/payment-methods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the payment methods available and the PSP that must be used for each payment method, and also if the account limit for the payment method is reached */
        get: operations["public.cashier.deposit.payment-methods"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/receipt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint for getting a receipt from a provider and provider transaction id */
        get: operations["public.cashier.deposit.receipt"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/request-cache": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Sets the request data in cache and returns a token to retrieve it later */
        post: operations["public.cashier.deposit.set-request-cache"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/request-cache/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieves the cached request data using the token */
        get: operations["public.cashier.deposit.get-request-cache"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Fetches the status of a deposit */
        get: operations["public.cashier.deposit.status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/deposit/successful-count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["public.cashier.deposit.successful-count"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for initiating a withdrawal from the user's funds to their bank account */
        post: operations["public.cashier.withdraw"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns all available withdrawal accounts for the user */
        get: operations["public.cashier.withdraw.accounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/calculate-withdrawal-limits-and-fee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint for minimum possible fees and withdrawal limits for a specific payment method and amount */
        get: operations["public.cashier.withdraw.calculate-withdrawal-limits-and-fee"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for cancelling a withdrawal */
        post: operations["public.cashier.withdraw.cancel"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/cancel-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for cancelling all withdrawals */
        post: operations["public.cashier.withdraw.cancel-all"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Endpoint for initiating an open loop withdrawal */
        post: operations["public.cashier.withdraw.open-loop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/cashier/withdraw/receipt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Endpoint for getting receipt for withdrawal */
        get: operations["public.cashier.withdraw.receipt"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/transactions/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns a paginated account activity view, showing all deposits, withdrawals, refunds and manual transactions for the user */
        get: operations["public.transactions.activity"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/transactions/withdrawals/cancel-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns information regarding the cancellable withdrawals for a user */
        get: operations["public.withdrawals.cancel-info"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/transactions/withdrawals/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns all recent withdrawals for the user, and a status saying if they can be cancelled */
        get: operations["public.transactions.withdrawals.recent"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** Account */
        Account: {
            /** Format: date-time */
            created_at: string;
            id: string;
            is_visible: boolean;
            payment_method: components["schemas"]["PaymentMethod"];
            psp: components["schemas"]["PSP"];
            /** Format: date-time */
            updated_at: string;
            user_id: string;
        };
        /** AccountBackofficeViewModel */
        AccountBackofficeViewModel: {
            block: components["schemas"]["PaymentMethodBlock"] | null;
            countryCode: string | null;
            /** Format: date-time */
            createdAt: string | null;
            established: boolean;
            /** Format: date-time */
            expiresAt: string | null;
            /** Format: date-time */
            firstSuccess: string | null;
            holderName: string | null;
            id: string;
            issuer: string | null;
            isVisible: boolean;
            /** Format: date-time */
            lastAttempt: string | null;
            /** Format: date-time */
            lastSuccess: string | null;
            paymentMethod: string;
            playerId: string;
            psp: string;
            pspUniqueReferenceId: string | null;
            publicIdentifier: string | null;
            scaStatus: components["schemas"]["ScaStatus"];
            /** Format: date-time */
            updatedAt: string | null;
            userId: number;
        };
        /** AccountCountResponse */
        AccountCountResponse: {
            count: number;
        };
        /** AccountOverview */
        AccountOverview: {
            block: components["schemas"]["PaymentMethodBlock"];
            /** Format: date-time */
            createdAt: string | null;
            depositsSum: string;
            established: boolean;
            /** Format: date-time */
            expiresAt: string | null;
            /** Format: date-time */
            firstSuccess: string | null;
            holderName: string | null;
            id: string;
            ignoreClosedLoop: boolean;
            ignoreClosedLoopLogs: components["schemas"]["IgnoreClosedLoopLogOverview"][];
            ignoreReasons: string[];
            issuer: string | null;
            isVisible: boolean;
            /** Format: date-time */
            lastAttempt: string | null;
            /** Format: date-time */
            lastSuccess: string | null;
            paymentMethod: string;
            playerId: string;
            playerIdsWithSamePURI: string[];
            psp: string;
            publicIdentifier: string | null;
            scaStatus: components["schemas"]["ScaStatus"];
            /** Format: date-time */
            updatedAt: string | null;
            userId: number;
            withdrawalsSum: string;
        };
        /** AccountsControllerIndexResponse */
        AccountsControllerIndexResponse: {
            accounts: components["schemas"]["BackofficeAccount"][];
        };
        /** AccountsControllerMitWithdrawableAccountsResponse */
        AccountsControllerMitWithdrawableAccountsResponse: {
            accounts: components["schemas"]["BackofficeMitWithdrawableAccount"][];
            closedLoopAccounts: components["schemas"]["BackofficeMitWithdrawableAccount"][];
            openLoopAccounts: components["schemas"]["BackofficeMitWithdrawableAccount"][];
        };
        /** AccountsUsedCountRequest */
        AccountsUsedCountRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** AccountsWithRecentSuccessRequest */
        AccountsWithRecentSuccessRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** AccountsWithRecentSuccessResponse */
        AccountsWithRecentSuccessResponse: {
            accounts: string;
        };
        /**
         * Acquirer
         * @enum {string}
         */
        Acquirer: Acquirer;
        /**
         * AcquirerReconciliationTransactionType
         * @enum {string}
         */
        AcquirerReconciliationTransactionType: AcquirerReconciliationTransactionType;
        /** ActiveAmountSinceRequest */
        ActiveAmountSinceRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * AdjustmentType
         * @enum {string}
         */
        AdjustmentType: AdjustmentType;
        /** AmountResponse */
        AmountResponse: {
            amount: string;
        };
        /**
         * App.Enums.States.DepositState
         * @description NOTE:  This is an enum reflecting an enum type used in the database.  Therefore, adding new values to this enum, must always be accompanied by a  new migration, which updates the enum type definition anywhere it is used.
         * @enum {string}
         */
        "App.Enums.States.DepositState": AppEnumsStatesDepositState;
        /**
         * App.Enums.States.RefundState
         * @description NOTE:  This is an enum reflecting an enum type used in the database.  Therefore, adding new values to this enum, must always be accompanied by a  new migration, which updates the enum type definition anywhere it is used.
         * @enum {string}
         */
        "App.Enums.States.RefundState": AppEnumsStatesRefundState;
        /**
         * App.Enums.States.WithdrawalState
         * @description NOTE:  This is an enum reflecting an enum type used in the database.  Therefore, adding new values to this enum, must always be accompanied by a  new migration, which updates the enum type definition anywhere it is used.
         * @enum {string}
         */
        "App.Enums.States.WithdrawalState": AppEnumsStatesWithdrawalState;
        /** App.Http.Requests.PlatformApi.WithdrawalsController.FinalizedForUserRequest */
        "App.Http.Requests.PlatformApi.WithdrawalsController.FinalizedForUserRequest": Record<string, never>;
        /** App.Http.Requests.PlatformApi.WithdrawalsController.HasSinceRequest */
        "App.Http.Requests.PlatformApi.WithdrawalsController.HasSinceRequest": {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** App.Http.Requests.PublicApi.DepositCashierController.SuccessfulDepositCountRequest */
        "App.Http.Requests.PublicApi.DepositCashierController.SuccessfulDepositCountRequest": {
            brand: components["schemas"]["Brand"];
        };
        /** App.Http.Requests.PublicApi.WithdrawalCashierController.CancelWithdrawalRequest */
        "App.Http.Requests.PublicApi.WithdrawalCashierController.CancelWithdrawalRequest": {
            transactionId: string;
        };
        /** App.Http.Responses.PlatformApi.WithdrawalController.FinalizedForUserResponse */
        "App.Http.Responses.PlatformApi.WithdrawalController.FinalizedForUserResponse": {
            withdrawals: string;
        };
        /** App.Http.Responses.PlatformApi.WithdrawalController.HasSinceResponse */
        "App.Http.Responses.PlatformApi.WithdrawalController.HasSinceResponse": {
            exists: boolean;
        };
        /** App.Http.Responses.PublicApi.DepositCashierController.SuccessfulDepositCountResponse */
        "App.Http.Responses.PublicApi.DepositCashierController.SuccessfulDepositCountResponse": {
            count: number;
        };
        /** ApproveRequest */
        ApproveRequest: {
            userId: string;
        };
        /** ApproveWithdrawalRequest */
        ApproveWithdrawalRequest: {
            withdrawal: components["schemas"]["Withdrawal"];
        };
        /** AuthorizeDepositAccountData */
        AuthorizeDepositAccountData: {
            block?: components["schemas"]["PaymentMethodBlock"] | null;
            /** @default false */
            established?: boolean;
            holderName?: string | null;
            id?: string | null;
            issuer?: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            pspUniqueReferenceId?: string | null;
            publicIdentifier?: string | null;
        };
        /** AuthorizeDepositRequest */
        AuthorizeDepositRequest: {
            account: components["schemas"]["AuthorizeDepositAccountData"];
            deposit: components["schemas"]["DepositRequestData"];
            psp: components["schemas"]["PSP"];
            userId: string;
        };
        /** AuthorizeRefundRequest */
        AuthorizeRefundRequest: {
            depositId: string;
            externalId: string;
        };
        /** AutomaticWithdrawalRequest */
        AutomaticWithdrawalRequest: {
            amount: string;
            brand: components["schemas"]["Brand"];
            userId: string;
        };
        /** BackofficeAccount */
        BackofficeAccount: {
            accountUuid: string;
            block: components["schemas"]["PaymentMethodBlock"];
            countryCode: string | null;
            expiryDate: string | null;
            holder: string | null;
            isExpired: boolean;
            lastSuccess: string | null;
            lastUsed: string;
            maskedAccount: string | null;
            noFailedTx: number;
            noSuccessfulTx: number;
            providerType: string;
            status: string;
            userIdsWithSamePURI: string;
            visible: string;
        };
        /** BackofficeMitWithdrawableAccount */
        BackofficeMitWithdrawableAccount: {
            displayText: string;
            id: string | null;
        };
        /** BalanceOverviewOfAccount */
        BalanceOverviewOfAccount: {
            accountId: string;
            accountName: string | null;
            /** Format: date-time */
            date: string;
            depositsSum: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            refundsSum: string | null;
            withdrawalsSum: string | null;
        };
        /** BalanceOverviewRequest */
        BalanceOverviewRequest: {
            /** Format: date-time */
            from?: string | null;
            playerId: string;
            /** Format: date-time */
            to?: string | null;
        };
        /** BalanceOverviewResponse */
        BalanceOverviewResponse: {
            data: components["schemas"]["BalanceOverviewOfAccount"][];
        };
        /** BlockAccountRequest */
        BlockAccountRequest: {
            blockedBy?: string | null;
            level: components["schemas"]["PaymentMethodBlock"];
            reason?: string | null;
        };
        /** BlockAccountResponse */
        BlockAccountResponse: {
            new_value: components["schemas"]["PaymentMethodBlock"];
            previous_value: components["schemas"]["PaymentMethodBlock"];
            success: boolean;
        };
        /** BlockAccountsRequest */
        BlockAccountsRequest: {
            blockedBy?: string | null;
            level: components["schemas"]["PaymentMethodBlock"];
            playerId: string;
            puris: string[];
            reason?: string | null;
        };
        /** BlockAccountsResponse */
        BlockAccountsResponse: {
            success: boolean;
        };
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand;
        /** CalculateFeeRequest */
        CalculateFeeRequest: {
            amount: string;
            /** @default true */
            isBonusToggled?: string;
            paymentMethod: components["schemas"]["PaymentMethod"];
        };
        /** CalculateFeeResponse */
        CalculateFeeResponse: {
            fee: string;
        };
        /** CancelWithdrawalRequest */
        CancelWithdrawalRequest: {
            withdrawals: Record<string, never>[];
        };
        /** CancelWithdrawalResponse */
        CancelWithdrawalResponse: {
            message: string | null;
            statuses: {
                [key: string]: boolean;
            };
        };
        /** CancelWithdrawalsRequest */
        CancelWithdrawalsRequest: {
            withdrawalIds: string[];
        };
        /**
         * CaptureMode
         * @enum {string}
         */
        CaptureMode: CaptureMode;
        /** CashierAccount */
        CashierAccount: {
            closedLoopAmount: number;
            estimatedWithdrawalTime: string;
            holderName: string | null;
            id: string | null;
            isOpenLoop: boolean;
            issuer: string | null;
            /** Format: date-time */
            lastAttempt: string | null;
            /** Format: date-time */
            lastSuccess: string | null;
            /** @default false */
            paymentMethodEnabled: boolean;
            psp: components["schemas"]["PSP"];
            publicIdentifier: string | null;
            type: components["schemas"]["PaymentMethod"];
            userId: string;
            withdrawable: boolean;
            withdrawableReason: string | null;
            withdrawOptions: components["schemas"]["Decimal"][];
        };
        /** Chargeback */
        Chargeback: {
            amount: string;
            arn: string | null;
            auth_code: string | null;
            card_number: string | null;
            card_scheme: string | null;
            chargeback_type: string | null;
            currency: string | null;
            fee_amount: string | null;
            fee_currency: string | null;
            is_represented: boolean | null;
            is_reversal: boolean | null;
            merchant_name: string;
            orig_reference_number: string | null;
            orig_request_id: string | null;
            orig_response_id: string | null;
            orig_trx_amount: string;
            orig_trx_currency: string | null;
            /** Format: date */
            orig_trx_date: string | null;
            /** Format: date */
            orig_trx_posting_date: string | null;
            orig_trx_settelment_amount: string | null;
            orig_trx_settelment_currency: string | null;
            orig_trx_type: string | null;
            payment_id: string;
            /** Format: date */
            posting_date: string;
            reason_code: string | null;
            reason_description: string | null;
            record_type: string;
            record_type_code: string;
            rrn: string | null;
            sub_merchant_id: number | null;
        };
        /**
         * ChargebackCaseData
         * @description A player's full chargeback case: the overview stats plus both lists for the detail page.
         *
         *     Balance = sum(chargeback amount + fees) - sum(active repayments); all chargebacks count,
         *     including reimbursed ones. Chargebacks without a deposit/account cannot be attributed to a
         *     player and never appear here.
         */
        ChargebackCaseData: {
            balance: string;
            chargeback_count: number;
            chargeback_total: string;
            chargebacks: components["schemas"]["ChargebackData"][];
            is_settled: boolean;
            player_id: string;
            repayment_count: number;
            repayment_total: string;
            repayments: components["schemas"]["ChargebackRepaymentData"][];
            user_ids: string;
        };
        /**
         * ChargebackCaseSummaryData
         * @description One player's chargeback case as shown on the overview.
         *
         *     Balance = sum(chargeback amount + fees) - sum(active repayments); all chargebacks count,
         *     including reimbursed ones.
         */
        ChargebackCaseSummaryData: {
            balance: string;
            chargeback_count: number;
            chargeback_total: string;
            is_settled: boolean;
            /** Format: date-time */
            last_chargeback_at: string | null;
            player_id: string;
            repayment_count: number;
            repayment_total: string;
            user_ids: string;
        };
        /**
         * ChargebackData
         * @description A master chargeback as exposed to the backoffice.
         *
         *     The owning user is derived through the deposit's account and is null when the chargeback has no
         *     linked deposit. deposit_external_id is the PSP's reference for the deposit.
         */
        ChargebackData: {
            acquirer: string;
            amount: string;
            /** Format: date-time */
            created_at: string | null;
            deposit_external_id: string | null;
            /** Format: date-time */
            deposit_finalized_at: string | null;
            deposit_id: string | null;
            events: components["schemas"]["ChargebackEventData"][];
            fees: string | null;
            id: number;
            message: string;
            /** Format: date-time */
            posted_at: string | null;
            /** Format: date-time */
            updated_at: string | null;
            user_id: number | null;
        };
        /**
         * ChargebackEventData
         * @description A single entry of a chargeback's event log as exposed to the backoffice.
         *
         *     occurred_at is when the event happened at its source (e.g. the acquirer posting date);
         *     created_at is when we recorded it.
         */
        ChargebackEventData: {
            /** Format: date-time */
            created_at: string | null;
            /** Format: date-time */
            occurred_at: string | null;
            type: components["schemas"]["ChargebackEventType"];
        };
        /**
         * ChargebackEventType
         * @description The type of an entry in a chargeback's event log. REIMBURSED: the acquirer took the disputed funds from our account and paid the party who raised the chargeback.
         * @enum {string}
         */
        ChargebackEventType: ChargebackEventType;
        /**
         * ChargebackRepaymentData
         * @description A chargeback repayment as exposed to the backoffice.
         *
         *     posted_at is the bank posting date (pure date); created_by/deleted_by hold the acting
         *     employee's username taken from the remote-user header.
         */
        ChargebackRepaymentData: {
            amount: string;
            bank_reference: string | null;
            /** Format: date-time */
            created_at: string | null;
            created_by: string;
            /** Format: date-time */
            deleted_at: string | null;
            deleted_by: string | null;
            id: number;
            note: string | null;
            player_id: string;
            /** Format: date */
            posted_at: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** ClosedLoopControllerAccount */
        ClosedLoopControllerAccount: {
            accountId: string;
            ignoreClosedLoopLogs: components["schemas"]["IgnoreClosedLoopLogOverview"][];
            ignoreReason: string;
            isVisible: boolean;
            maxWithdrawal: string;
            netDeposit: string;
            paymentMethod: string;
            publicIdentifier: string | null;
        };
        /** ClosedLoopControllerIndexResponse */
        ClosedLoopControllerIndexResponse: {
            closedLoopAccounts: components["schemas"]["ClosedLoopControllerAccount"][];
            freeAmount: string;
            withdrawableBalance: string;
        };
        /** CombinedAccountOverview */
        CombinedAccountOverview: {
            accounts: components["schemas"]["AccountOverview"][];
            blocks: string[];
            depositsSum: string;
            /** Format: date-time */
            firstSuccess: string | null;
            holderName: string | null;
            ignoreReasons: string[];
            issuer: string | null;
            /** Format: date-time */
            lastSuccess: string | null;
            paymentMethod: string;
            playerIdsWithSamePURIs: string[];
            publicIdentifier: string | null;
            puris: string[];
            withdrawalsSum: string;
        };
        /** CombinedAccountOverviewRequest */
        CombinedAccountOverviewRequest: {
            playerId: string;
        };
        /** CombinedAccountOverviewResponse */
        CombinedAccountOverviewResponse: {
            data: components["schemas"]["CombinedAccountOverview"][];
        };
        /** CreateChargebackRepaymentRequest */
        CreateChargebackRepaymentRequest: {
            amount: number;
            bankReference?: string | null;
            note?: string | null;
            /** Format: uuid */
            playerId: string;
            /** Format: date */
            postedAt: string;
        };
        /** CreateCitWithdrawalResponse */
        CreateCitWithdrawalResponse: {
            messages: string[];
            receipt: components["schemas"]["WithdrawalReceipt"];
            redirect: components["schemas"]["SCARedirect"] | null;
            state: components["schemas"]["App.Enums.States.WithdrawalState"];
            success: boolean;
        };
        /** CreateFirstDepositRequest */
        CreateFirstDepositRequest: {
            amount?: string | null;
            brand: components["schemas"]["Brand"];
            captureMode?: components["schemas"]["CaptureMode"] | null;
            clientIp?: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            redirectInfo: components["schemas"]["RedirectInfo"];
            seonSession?: string | null;
            sessionId?: string | null;
            userAgent?: string | null;
            userId: string;
            userInfo: components["schemas"]["UserInfo"];
        };
        /** CreateManualTransactionRequest */
        CreateManualTransactionRequest: {
            amount: string;
            createdByEmployee: string;
            internalDescription: string;
            type: components["schemas"]["ManualTransactionType"];
            userDescription: string;
            userId: string;
        };
        /** CreateMitWithdrawalOnExistingAccountRequest */
        CreateMitWithdrawalOnExistingAccountRequest: {
            accountId: string;
            amount: string;
            brand: components["schemas"]["Brand"];
            createdBy: string;
        };
        /** CreateMitWithdrawalOnNewAccountRequest */
        CreateMitWithdrawalOnNewAccountRequest: {
            amount: string;
            brand: components["schemas"]["Brand"];
            createdBy: string;
            paymentMethod: components["schemas"]["PaymentMethod"];
            userId: string;
        };
        /** CreateOpenLoopWithdrawalData */
        CreateOpenLoopWithdrawalData: {
            amount: number;
            brand: components["schemas"]["Brand"];
            paymentMethod: components["schemas"]["PaymentMethod"];
            seonSession?: string | null;
        };
        /** CreateProviderQuickDepositRequest */
        CreateProviderQuickDepositRequest: {
            account: components["schemas"]["Account"];
            amount: string;
            brand: components["schemas"]["Brand"];
            captureMode?: components["schemas"]["CaptureMode"] | null;
            channel: string;
            clientIp?: string | null;
            redirectInfo?: components["schemas"]["RedirectInfo"] | null;
            seonSession?: string | null;
            sessionId?: string | null;
            userAgent?: string | null;
            userInfo: components["schemas"]["UserInfo"];
        };
        /** CreateProviderRefundRequest */
        CreateProviderRefundRequest: {
            refund: components["schemas"]["Refund"];
        };
        /** CreateProviderWithdrawalRequest */
        CreateProviderWithdrawalRequest: {
            clientIp?: string | null;
            redirectInfo?: components["schemas"]["RedirectInfo"] | null;
            seonSession?: string | null;
            sessionId?: string | null;
            userAgent?: string | null;
            userInfo?: components["schemas"]["UserInfo"] | null;
            withdrawal: components["schemas"]["Withdrawal"];
        };
        /** CreateRefundRequest */
        CreateRefundRequest: {
            initiatedBy?: string | null;
        };
        /** CreateRefundResponse */
        CreateRefundResponse: {
            message: string;
            success: boolean;
        };
        /** CreateWithdrawalData */
        CreateWithdrawalData: {
            accountId: string;
            amount: number;
            brand: components["schemas"]["Brand"];
            seonSession?: string | null;
        };
        /** CreateWithdrawalResponse */
        CreateWithdrawalResponse: {
            adminErrorMessage: string | null;
            redirect: components["schemas"]["SCARedirect"] | null;
            success: boolean;
            userErrorMessage: string | null;
        };
        /** CredoraxChargebackData */
        CredoraxChargebackData: {
            chargeback: components["schemas"]["Chargeback"];
            transactionId: string;
        };
        /**
         * Currency
         * @enum {string}
         */
        Currency: Currency;
        /** CustomEventData */
        CustomEventData: {
            num_payments: number;
            partner_id: number | null;
            partner_name: string | null;
            partner_user_id: string | null;
            payment_amount: string;
            payment_id: string;
            site_name: string;
            user_id: string;
        };
        /** Decimal */
        Decimal: string;
        /** DenyRequest */
        DenyRequest: {
            reason: string;
            userId: string;
        };
        /** DenyWithdrawalRequest */
        DenyWithdrawalRequest: {
            withdrawal: components["schemas"]["Withdrawal"];
        };
        /** Deposit */
        Deposit: {
            account: components["schemas"]["Account"];
            account_id: string;
            acquirer?: components["schemas"]["Acquirer"] | null;
            amount: string;
            brand: components["schemas"]["Brand"];
            /** Format: date-time */
            created_at: string;
            external_id: string;
            id: string;
            state: components["schemas"]["DepositState"];
            /** Format: date-time */
            updated_at: string;
        };
        /** DepositAccountsResponse */
        DepositAccountsResponse: {
            accounts: components["schemas"]["CashierAccount"][];
        };
        /** DepositAttributesRequest */
        DepositAttributesRequest: {
            accountId?: string | null;
            brand: components["schemas"]["Brand"];
            redirectInfo?: components["schemas"]["RedirectInfo"] | null;
            userId: number;
        };
        /** DepositConfigResponse */
        DepositConfigResponse: {
            fees: components["schemas"]["DepositFee"][];
            limits: components["schemas"]["TransactionAmountLimits"];
            numberOfDeposits: number;
            options: string[];
        };
        /** DepositConfigsRequest */
        DepositConfigsRequest: {
            brand: components["schemas"]["Brand"];
        };
        /** DepositFee */
        DepositFee: {
            flatFee: components["schemas"]["Decimal"];
            maxAmount: components["schemas"]["Decimal"];
            minAmount: components["schemas"]["Decimal"];
            paymentMethod: components["schemas"]["PaymentMethod"];
            percentageFee: components["schemas"]["Decimal"];
        };
        /** DepositMeta */
        DepositMeta: {
            arn: string | null;
            cardCountryCode: string | null;
            cardHolderNameMismatch: boolean | null;
            cardScheme: string | null;
            cardSegment: string | null;
            cardType: string | null;
            isQuickPay: boolean | null;
            userMessage: string | null;
        };
        /** DepositOptionsRequest */
        DepositOptionsRequest: {
            brand: components["schemas"]["Brand"];
            gameInstanceId?: string | null;
            gameSlug?: string | null;
            isPlaygame: boolean;
            paymentMethod: components["schemas"]["PaymentMethod"];
            psp: components["schemas"]["PSP"];
        };
        /** DepositReceipt */
        DepositReceipt: {
            account: components["schemas"]["CashierAccount"];
            amount: string;
            /** Format: date-time */
            createdAt: string;
            fee: string;
            firstDepositType: components["schemas"]["FirstDepositType"] | null;
            gtmEvent: components["schemas"]["GtmEvent"] | null;
            isFirstDeposit: boolean;
            transactionId: string;
        };
        /** DepositReceiptData */
        DepositReceiptData: {
            provider: components["schemas"]["PSP"];
            providerTransactionId: string;
        };
        /**
         * DepositRequestCacheAttributesResponse
         * @description The deposit request-cache `attributes` sub-object, shared by DepositRequestCacheRequest
         *     (binds/validates it) and DepositRequestCacheResponse (echoes it back unchanged).
         */
        DepositRequestCacheAttributesResponse: {
            brand?: components["schemas"]["Brand"];
            cancelUrl?: string;
            failureUrl?: string;
            isQuickPay?: boolean;
            pendingUrl?: string;
            SeonSession?: string;
            SeonSessionId?: string;
            storeAccount?: boolean;
            successUrl?: string;
            userAgent?: string;
            useReferenceTransaction?: boolean;
        };
        /**
         * DepositRequestCacheRequest
         * @description The concrete deposit request-cache contract bound + validated by setRequestCache.
         *
         *     Variant-specific fields use Optional (not nullable) so unsent keys are omitted from the
         *     cached payload, preserving the exact object the frontend replays after the PSP redirect.
         *     getRequestCache echoes this back as the mirror DepositRequestCacheResponse.
         *
         *     `attributes` is Optional, alongside the flat redirect-URL fields, because the
         *     quick-deposit/ePay flow posts redirect URLs flat with no `attributes` object.
         */
        DepositRequestCacheRequest: {
            accountId?: string;
            amount: string;
            attributes?: components["schemas"]["DepositRequestCacheAttributesResponse"];
            brand: components["schemas"]["Brand"];
            cancelUrl?: string;
            cardHolder?: string;
            encCreditcardNumber?: string;
            encCvv?: string;
            expiryMonth?: string;
            expiryYear?: string;
            failureUrl?: string;
            fraudnetRiskSessionCorrelationId?: string;
            gameInstanceId?: string;
            gameSlug?: string;
            isPlaygame?: boolean;
            merchantId?: string;
            paymentMethod?: components["schemas"]["PaymentMethod"];
            pendingUrl?: string;
            phoneNumber?: string;
            psp?: components["schemas"]["PSP"];
            seonSession?: string;
            sessionId?: string;
            storeAccount?: boolean;
            successUrl?: string;
            url: string;
            userId?: string;
        };
        /**
         * DepositRequestCacheResponse
         * @description The deposit request-cache payload returned by getRequestCache.
         *
         *     Mirrors DepositRequestCacheRequest field-for-field so the cached request round-trips
         *     unchanged: whatever setRequestCache stored is echoed back with identical types for the
         *     frontend to replay after the PSP redirect. Keep the two in sync — a field present on one
         *     but not the other silently breaks the round-trip.
         *
         *     `attributes` is Optional, alongside the flat redirect-URL fields, because the
         *     quick-deposit/ePay flow posts redirect URLs flat with no `attributes` object.
         */
        DepositRequestCacheResponse: {
            accountId?: string;
            amount: string;
            attributes?: components["schemas"]["DepositRequestCacheAttributesResponse"];
            brand: components["schemas"]["Brand"];
            cancelUrl?: string;
            cardHolder?: string;
            encCreditcardNumber?: string;
            encCvv?: string;
            expiryMonth?: string;
            expiryYear?: string;
            failureUrl?: string;
            fraudnetRiskSessionCorrelationId?: string;
            gameInstanceId?: string;
            gameSlug?: string;
            isPlaygame?: boolean;
            merchantId?: string;
            paymentMethod?: components["schemas"]["PaymentMethod"];
            pendingUrl?: string;
            phoneNumber?: string;
            psp?: components["schemas"]["PSP"];
            seonSession?: string;
            sessionId?: string;
            storeAccount?: boolean;
            successUrl?: string;
            url: string;
            userId?: string;
        };
        /** DepositRequestData */
        DepositRequestData: {
            amount: string;
            brand: components["schemas"]["Brand"];
            captureMode?: components["schemas"]["CaptureMode"] | null;
            cardCountryCode?: string | null;
            cardScheme?: string | null;
            cardSegment?: string | null;
            cardType?: string | null;
            externalId: string;
            ipAddress?: string | null;
            isQuickPay?: boolean | null;
            scaMode?: components["schemas"]["ScaMode"] | null;
            seonSession?: string | null;
            seonSessionId?: string | null;
            userAgent?: string | null;
        };
        /** DepositsControllerIndexRequest */
        DepositsControllerIndexRequest: {
            /** Format: date-time */
            from?: string | null;
            /** @default 1 */
            page?: number;
            perPage?: number | null;
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * DepositState
         * @enum {string}
         */
        DepositState: DepositState;
        /** DepositStatsData */
        DepositStatsData: {
            count: number;
            sum: string;
        };
        /** DepositStatsRequest */
        DepositStatsRequest: {
            /** Format: date-time */
            from?: string | null;
            playerId: string;
            /** Format: date-time */
            to?: string | null;
        };
        /** DepositStatsResponse */
        DepositStatsResponse: {
            failedDepositStatsData: components["schemas"]["DepositStatsData"];
            successfulDepositStatsData: components["schemas"]["DepositStatsData"];
        };
        /** DepositStatusRequest */
        DepositStatusRequest: {
            provider: components["schemas"]["PSP"];
            providerTransactionId: string;
        };
        /** DepositStatusResponse */
        DepositStatusResponse: {
            firstDepositType: components["schemas"]["FirstDepositType"] | null;
            message: string | null;
            pspStatusCode: string | null;
            state: components["schemas"]["TransactionState"];
            statusCode: components["schemas"]["PaymentStatusCode"] | null;
        };
        /** DynamicConfigData */
        DynamicConfigData: {
            key: string;
            namespace: string;
            value: string;
        };
        /** DynamicConfigImportConfigResponse */
        DynamicConfigImportConfigResponse: {
            importFrom: string;
            importTo: string;
            successUrl: string;
        };
        /** EstablishedForPlayerRequest */
        EstablishedForPlayerRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** EstablishedForPlayerResponse */
        EstablishedForPlayerResponse: {
            accounts: string;
        };
        /** EstablishedForUserRequest */
        EstablishedForUserRequest: Record<string, never>;
        /** EstablishedForUserResponse */
        EstablishedForUserResponse: {
            accounts: string;
        };
        /**
         * FailedDepositReason
         * @enum {string}
         */
        FailedDepositReason: FailedDepositReason;
        /** FailedDepositRequest */
        FailedDepositRequest: {
            /** Format: uuid */
            accountId?: string | null;
            amount: number;
            brand: components["schemas"]["Brand"];
            errorCode?: string | null;
            errorMessage?: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            psp: components["schemas"]["PSP"];
            reason: components["schemas"]["FailedDepositReason"];
        };
        /** FailedDepositResponse */
        FailedDepositResponse: {
            id: string;
        };
        /** FetchChargebacksRequest */
        FetchChargebacksRequest: {
            /** @default [] */
            filters?: {
                [key: string]: string;
            };
            /** @default 1 */
            page?: number;
            /** @default 15 */
            perPage?: number;
        };
        /** FinalizedAmountRequest */
        FinalizedAmountRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** FinalizeDepositRequest */
        FinalizeDepositRequest: {
            account: components["schemas"]["UpdatableAccountData"];
            deposit: components["schemas"]["UpdatableDepositData"];
        };
        /** FinalizedForUserRequest */
        FinalizedForUserRequest: Record<string, never>;
        /** FinalizedForUserResponse */
        FinalizedForUserResponse: {
            deposits: string;
        };
        /** FinalizeRefundRequest */
        FinalizeRefundRequest: {
            refund: components["schemas"]["UpdatableRefundData"];
        };
        /** FinalizeWithdrawalData */
        FinalizeWithdrawalData: {
            acquirer: string;
        };
        /** FinalizeWithdrawalRequest */
        FinalizeWithdrawalRequest: {
            account: components["schemas"]["UpdatableAccountData"];
            withdrawal: components["schemas"]["FinalizeWithdrawalData"];
        };
        /** FinanceDocumentData */
        FinanceDocumentData: {
            category: string | null;
            /** Format: date-time */
            created_at: string;
            id: number;
            key: string;
            /** Format: date-time */
            last_processed_at: string | null;
            original_filename: string | null;
            size: number | null;
        };
        /** FindByIdsRequest */
        FindByIdsRequest: {
            ids: string[];
        };
        /** FindByIdsResponse */
        FindByIdsResponse: {
            withdrawals: string;
        };
        /** FirstDepositRequest */
        FirstDepositRequest: {
            amount?: number | null;
            brand: components["schemas"]["Brand"];
            gameInstanceId?: string | null;
            gameSlug?: string | null;
            /** @default false */
            isPlaygame?: boolean;
            paymentMethod: components["schemas"]["PaymentMethod"];
            psp: components["schemas"]["PSP"];
            seonSession?: string | null;
        };
        /** FirstDepositResponse */
        FirstDepositResponse: {
            message: string;
            providerTransactionId: string | null;
            pspClient: components["schemas"]["PSPClient"] | null;
            SCARedirect: components["schemas"]["SCARedirect"] | null;
            success: boolean;
        };
        /**
         * FirstDepositType
         * @enum {string}
         */
        FirstDepositType: FirstDepositType;
        /** ForceStateRequest */
        ForceStateRequest: {
            newState: string;
            reason: string;
            transactionId: string;
            type: components["schemas"]["TransactionType"];
        };
        /** GetAllowedStatesRequest */
        GetAllowedStatesRequest: {
            type: components["schemas"]["TransactionType"];
        };
        /** GetAllowedStatesResponse */
        GetAllowedStatesResponse: {
            states: string[];
        };
        /** GetArnRequest */
        GetArnRequest: {
            paymentId: string;
            transactionType: components["schemas"]["TransactionType"];
        };
        /** GetArnResponse */
        GetArnResponse: {
            arn: string;
        };
        /** GetKycStatusRequest */
        GetKycStatusRequest: {
            depositId: string;
            status: components["schemas"]["KycStatus"];
        };
        /** GetPaymentInformationRequest */
        GetPaymentInformationRequest: {
            paymentId: string;
            transactionType: components["schemas"]["TransactionType"];
        };
        /** GetPaymentInformationResponse */
        GetPaymentInformationResponse: {
            paymentInformation: {
                [key: string]: unknown;
            };
        };
        /** GtmEvent */
        GtmEvent: {
            currency: components["schemas"]["Currency"];
            custom_event_data: components["schemas"]["CustomEventData"];
            event: string;
            user_data: components["schemas"]["UserData"];
            value: string;
        };
        /** HasFinalizedRequest */
        HasFinalizedRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** HasFinalizedResponse */
        HasFinalizedResponse: {
            exists: boolean;
        };
        /** HasRecentSuccessWithDifferentPaymentMethodRequest */
        HasRecentSuccessWithDifferentPaymentMethodRequest: {
            /** Format: date-time */
            from?: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            /** Format: date-time */
            to?: string | null;
        };
        /** HasRecentSuccessWithDifferentPaymentMethodResponse */
        HasRecentSuccessWithDifferentPaymentMethodResponse: {
            exists: boolean;
        };
        /** HasSinceRequest */
        HasSinceRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** HasSinceResponse */
        HasSinceResponse: {
            exists: boolean;
        };
        /** HasUserMadeADepositResponse */
        HasUserMadeADepositResponse: {
            userHasMadeADeposit: boolean;
        };
        /** IgnoreClosedLoopLogOverview */
        IgnoreClosedLoopLogOverview: {
            changed_by: string | null;
            /** Format: date-time */
            created_at: string | null;
            reason: string;
            state: boolean;
        };
        /** IndexRequest */
        IndexRequest: {
            brand?: components["schemas"]["Brand"] | null;
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
            userIds: number[];
        };
        /** IndexResponse */
        IndexResponse: {
            manual_transactions: components["schemas"]["ManualTransactionData"][];
        };
        /** JackpotStats */
        JackpotStats: {
            amountOfRecentJackpot: string | null;
            jackpotsCount: number;
            jackpotsSum: string;
            /** Format: date-time */
            timeOfRecentJackpot: string | null;
        };
        /**
         * KycStatus
         * @enum {string}
         */
        KycStatus: KycStatus;
        /** LastSuccessfulDepositTimeRequest */
        LastSuccessfulDepositTimeRequest: Record<string, never>;
        /** LastSuccessfulDepositTimeResponse */
        LastSuccessfulDepositTimeResponse: {
            /** Format: date-time */
            time: string | null;
        };
        /** LastSuccessfulForUserRequest */
        LastSuccessfulForUserRequest: {
            brand?: components["schemas"]["Brand"] | null;
        };
        /** LastSuccessfulForUserResponse */
        LastSuccessfulForUserResponse: {
            deposit: string | null;
        };
        /** ListChargebackCasesRequest */
        ListChargebackCasesRequest: {
            /** @default true */
            outstandingOnly?: boolean;
            /** @default 1 */
            page?: number;
            /** @default 24 */
            perPage?: number;
            /** Format: uuid */
            playerId?: string | null;
            userId?: string | null;
        };
        /** ListChargebackCasesResponse */
        ListChargebackCasesResponse: {
            data: components["schemas"]["ChargebackCaseSummaryData"][];
            meta: components["schemas"]["PaginationMeta"];
            unattributed_chargeback_count: number;
        };
        /** ListFinanceDocumentsRequest */
        ListFinanceDocumentsRequest: {
            category?: string | null;
            page?: number | null;
            /** @default 100 */
            perPage?: number;
        };
        /** ListFinanceDocumentsResponse */
        ListFinanceDocumentsResponse: {
            data: components["schemas"]["FinanceDocumentData"][];
            meta: components["schemas"]["PaginationMeta"];
        };
        /** ListMonthlySettlementAdjustmentsRequest */
        ListMonthlySettlementAdjustmentsRequest: {
            acquirers?: components["schemas"]["Acquirer"][] | null;
            month: number;
            year: number;
        };
        /** ListMonthlySettlementAdjustmentsResponse */
        ListMonthlySettlementAdjustmentsResponse: {
            data: components["schemas"]["SettlementAdjustmentAcquirerGroupData"][];
        };
        /** ListSettlementSummariesRequest */
        ListSettlementSummariesRequest: {
            page?: number | null;
            /** @default 100 */
            perPage?: number;
        };
        /** ListSettlementSummariesResponse */
        ListSettlementSummariesResponse: {
            data: components["schemas"]["SettlementSummaryData"][];
            meta: components["schemas"]["PaginationMeta"];
        };
        /** ListUnreconciledTransactionsRequest */
        ListUnreconciledTransactionsRequest: {
            acquirers?: components["schemas"]["Acquirer"][] | null;
            /** Format: date */
            from_date: string;
            page?: number | null;
            per_page?: number | null;
            /** Format: date */
            to_date: string;
        };
        /** ListUnreconciledTransactionsResponse */
        ListUnreconciledTransactionsResponse: {
            data: components["schemas"]["UnreconciledEntryData"][];
            meta: components["schemas"]["PaginationMeta"];
        };
        /** ManuallyApprovedWithdrawalData */
        ManuallyApprovedWithdrawalData: {
            amount: string;
            /** Format: date-time */
            createdAt: string;
            reason: string;
        };
        /** ManuallyApprovedWithdrawalForPlayerRequest */
        ManuallyApprovedWithdrawalForPlayerRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** ManuallyApprovedWithdrawalForPlayerResponse */
        ManuallyApprovedWithdrawalForPlayerResponse: {
            logs: components["schemas"]["ManuallyApprovedWithdrawalData"][];
        };
        /** ManualTransactionData */
        ManualTransactionData: {
            amount: string;
            /** Format: date-time */
            created_at: string;
            created_by_employee: string;
            id: string;
            internal_description: string;
            type: components["schemas"]["ManualTransactionType"];
            /** Format: date-time */
            updated_at: string;
            user_description: string;
            user_id: string;
        };
        /** ManualTransactionsAmountForTypeRequest */
        ManualTransactionsAmountForTypeRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
            type: components["schemas"]["ManualTransactionType"];
        };
        /**
         * ManualTransactionType
         * @enum {string}
         */
        ManualTransactionType: ManualTransactionType;
        /** MassUpdateStateRequest */
        MassUpdateStateRequest: {
            externalIds: string[];
            newState: string;
            psp: components["schemas"]["PSP"];
            reason: string;
            type: components["schemas"]["TransactionType"];
        };
        /** MaxAmountRequest */
        MaxAmountRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** MessageResponse */
        MessageResponse: {
            message: string;
            success: boolean;
        };
        /** MinimumFeeRequest */
        MinimumFeeRequest: {
            userId: number;
        };
        /** MinimumWithdrawalAmountRequest */
        MinimumWithdrawalAmountRequest: {
            amount: string;
            paymentMethod: components["schemas"]["PaymentMethod"];
        };
        /** ModelSearchResponse */
        ModelSearchResponse: {
            current_page: number;
            data: unknown[];
            last_page: number;
            per_page: number;
            total: number;
            warnings: string[];
        };
        /** Modules.Backoffice.Http.Requests.IndexRequest */
        "Modules.Backoffice.Http.Requests.IndexRequest": {
            /** @default 1 */
            page?: number;
            /** @default 50 */
            perPage?: number;
            /** @default [] */
            searchedKeys?: {
                [key: string]: unknown;
            };
        };
        /** NeedApprovalWithdrawalIndexResponse */
        NeedApprovalWithdrawalIndexResponse: {
            current_page: number;
            data: components["schemas"]["WithdrawalViewData"][];
            last_page: number;
            per_page: number;
            total: number;
        };
        /** NonFailedStatsRequest */
        NonFailedStatsRequest: {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
            userIds?: number[] | null;
        };
        /** NonFailedStatsResponse */
        NonFailedStatsResponse: {
            count: number;
            sum: string;
        };
        /** PaginationMeta */
        PaginationMeta: {
            current_page: number;
            last_page: number;
            per_page: number;
            total: number;
        };
        /** Paginator */
        Paginator: {
            current_page: number;
            current_page_url: string;
            data: string;
            first_page_url: string;
            from: number | null;
            next_page_url: string;
            path: string | null;
            per_page: number;
            prev_page_url: string | null;
            to: number | null;
        };
        /**
         * PaymentMethod
         * @enum {string}
         */
        PaymentMethod: PaymentMethod;
        /** PaymentMethodAmountRequest */
        PaymentMethodAmountRequest: {
            /** Format: date-time */
            from?: string | null;
            paymentMethod: components["schemas"]["PaymentMethod"];
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * PaymentMethodBlock
         * @description Enum for payment account block levels. Used by payments to block the usage of a specific payment account.
         *     | |
         *     |---|
         *     | `NONE` <br/> Account is not blocked |
         *     | `LOCAL` <br/> Account is blocked for a specific account |
         *     | `GLOBAL` <br/> Account is blocked for all accounts |
         * @enum {string}
         */
        PaymentMethodBlock: PaymentMethodBlock;
        /** PaymentMethodOption */
        PaymentMethodOption: {
            accountLimitReached: boolean;
            paymentMethod: components["schemas"]["PaymentMethod"];
            psp: components["schemas"]["PSP"];
        };
        /** PaymentMethodOptionsResponse */
        PaymentMethodOptionsResponse: {
            options: components["schemas"]["PaymentMethodOption"][];
        };
        /**
         * PaymentsControllerDetailsResponse
         * @description Response data for the payment details view in platform BO
         */
        PaymentsControllerDetailsResponse: {
            acquirer: components["schemas"]["Acquirer"] | null;
            amount: string;
            brand: components["schemas"]["Brand"];
            fee: string | null;
            id: string;
            issuer: string | null;
            masked_account: string | null;
            psp: components["schemas"]["PSP"];
            psp_origin_transaction_id: string | null;
            psp_status_code: string | null;
            psp_transaction_id: string | null;
            reason: string | null;
            refundable: boolean;
            /** Format: date-time */
            refunded_at: string | null;
            status_code: components["schemas"]["PaymentStatusCode"] | null;
            type: components["schemas"]["TransactionType"];
            user_id: string;
        };
        /** PaymentsControllerIndexRequest */
        PaymentsControllerIndexRequest: {
            /** Format: date-time */
            from?: string | null;
            /** @default 1 */
            page?: number;
            perPage?: number | null;
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * PaymentStatusCode
         * @description | |
         *     |---|
         *     | `FRAUD` <br/> Bank refused payment because of suspected fraud |
         *     | `SUCCESS` <br/> Payment succeeded |
         *     | `NO_FUNDS` <br/> Bank refused payment because of insufficient funds |
         *     | `REVERSED` <br/> Transaction was reversed |
         *     | `KYC_BLOCK` <br/> Rejected due to KYC fraud detection |
         *     | `BIN_BLOCK` <br/> Transaction was rejected because of the bin |
         *     | `GUARD_BLOCK` <br/> Transaction did not pass all guards |
         *     | `SCA_FAILURE` <br/> User did not pass SCA successfully |
         *     | `MISSING_SCA` <br/> User did not complete SCA |
         *     | `BANK_REFUSAL` <br/> Bank refused payment because of suspected fraud |
         *     | `INVALID_INPUT` <br/> User failed to input correct card information |
         *     | `GENERAL_ERROR` <br/> Fallback error |
         *     | `MISSING_INPUT` <br/> User did not fill in the required information |
         *     | `VELOCITY_BLOCK` <br/> User has made too transactions in a row |
         *     | `RESTRICTED_USER` <br/> The associated user has either been suspended or closed |
         *     | `LIMIT_OVERDRAWN` <br/> Bank refused payment because of insufficient funds |
         *     | `MONEY_LIMIT_BLOCK` <br/> User reached daily, weekly, or transactional limits imposed by money-limits |
         *     | `CANCELLED_BY_USER` <br/> User cancelled transaction |
         *     | `EXPIRED_PAYMENT_METHOD` <br/> The card or account details saved are out-of-date |
         *     | `SCA_REQUIRED_BY_ISSUER` <br/> bank or card issuer has rejected the deposit because it requires SCA |
         *     | `RESTRICTED_PAYMENT_METHOD` <br/> Users bank or card issuer has blocked the transaction due to security (potential fraud), unsupported international/online gambling |
         *     | `ACCOUNT_NOT_FOUND` <br/> Users account was not found |
         *     | `CARD_BLOCKED` <br/> Card has been blocked in backoffice |
         *     | `CARD_PIN_ISSUE` <br/> Typically means users card is temporarily blocked after too many incorrect attempts |
         *     | `ACQUIRER_ERROR` <br/> Groups acquirer-related error codes |
         *     | `ISSUER_DOWN` <br/> User's bank is temporarily unavailable and cannot process the request |
         * @enum {string}
         */
        PaymentStatusCode: PaymentStatusCode;
        /** PayoutsControllerIndexRequest */
        PayoutsControllerIndexRequest: {
            /** Format: date-time */
            from?: string | null;
            /** @default 1 */
            page?: number;
            perPage?: number | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** PlayerTransactionsRequest */
        PlayerTransactionsRequest: {
            /** Format: date-time */
            from?: string | null;
            playerId: string;
            /** Format: date-time */
            to?: string | null;
        };
        /** PlayerTransactionsResponse */
        PlayerTransactionsResponse: {
            data: components["schemas"]["TransactionViewModel"][];
        };
        /** PositiveTypeSumResponse */
        PositiveTypeSumResponse: {
            sum: string;
        };
        /**
         * PSP
         * @enum {string}
         */
        PSP: PSP;
        /** PSPClient */
        PSPClient: {
            attributes: {
                [key: string]: unknown;
            };
            clientUrl: string;
            key: string;
        };
        /** QuickDepositRequest */
        QuickDepositRequest: {
            accountId: string;
            amount: number;
            brand: components["schemas"]["Brand"];
            gameInstanceId?: string | null;
            gameSlug?: string | null;
            isPlaygame: boolean;
            seonSession?: string | null;
        };
        /** QuickDepositResponse */
        QuickDepositResponse: {
            extendedProviderTransactionId: string | null;
            messages: string[];
            provider: components["schemas"]["PSP"] | null;
            providerTransactionId: string | null;
            pspClient: components["schemas"]["PSPClient"] | null;
            scaRedirect: components["schemas"]["SCARedirect"] | null;
            success: boolean;
        };
        /** RavenTrackMetricsRequest */
        RavenTrackMetricsRequest: {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
            userIds: number[];
        };
        /** RavenTrackMetricsResponse */
        RavenTrackMetricsResponse: {
            data: [
                string,
                ...string[]
            ];
        };
        /** RecalculateSettlementSummaryRequest */
        RecalculateSettlementSummaryRequest: {
            financeDocumentIds: number[];
        };
        /** RecalculateSettlementSummaryResponse */
        RecalculateSettlementSummaryResponse: {
            finance_document_ids: string;
            message: string;
        };
        /** ReceiveDynamicConfigsRequest */
        ReceiveDynamicConfigsRequest: {
            configs: components["schemas"]["DynamicConfigData"][];
        };
        /** RedirectInfo */
        RedirectInfo: {
            query: string;
            url: string;
        };
        /** Refund */
        Refund: {
            acquirer?: components["schemas"]["Acquirer"] | null;
            /** Format: date-time */
            created_at: string;
            deposit: components["schemas"]["Deposit"];
            external_id?: string | null;
            id: string;
            state: components["schemas"]["RefundState"];
            /** Format: date-time */
            updated_at: string;
        };
        /** RefundMeta */
        RefundMeta: Record<string, never>;
        /**
         * RefundState
         * @enum {string}
         */
        RefundState: RefundState;
        /** RejectRequest */
        RejectRequest: {
            /** @default false */
            allowFinalized?: boolean;
            pspStatusCode?: string | null;
            reason?: string | null;
            /** @default UNKNOWN */
            scaStatus?: components["schemas"]["ScaStatus"];
            statusCode: components["schemas"]["PaymentStatusCode"];
        };
        /** RevertWithdrawalRequest */
        RevertWithdrawalRequest: {
            reason: string;
            withdrawals: Record<string, never>[];
        };
        /** RevertWithdrawalResponse */
        RevertWithdrawalResponse: {
            message: string | null;
            statuses: {
                [key: string]: boolean;
            };
        };
        /** RevertWithdrawalsRequest */
        RevertWithdrawalsRequest: {
            reason: string;
            withdrawalIds: string[];
        };
        /** ScaAnalysis */
        ScaAnalysis: {
            forceForFirstDeposit: boolean;
            forceForNextDeposit: boolean;
        };
        /**
         * ScaMode
         * @description | |
         *     |---|
         *     | `NORMAL` <br/> Ask for PSP to decide |
         *     | `CHALLENGE` <br/> Ask for being challenged |
         *     | `EXEMPTION` <br/> Ask for being exempt from being challenged |
         *     | `SKIP` <br/> Ask for skip of being challenged |
         * @enum {string}
         */
        ScaMode: ScaMode;
        /** SCARedirect */
        SCARedirect: {
            container: components["schemas"]["WebContainer"];
            method: components["schemas"]["WebMethod"];
            parameters: {
                [key: string]: unknown;
            };
            url: string;
        };
        /**
         * ScaStatus
         * @enum {string}
         */
        ScaStatus: ScaStatus;
        /** SetDepositRequestCacheResponse */
        SetDepositRequestCacheResponse: {
            token: string;
            ttl: string;
        };
        /** SettlementAdjustmentAcquirerGroupData */
        SettlementAdjustmentAcquirerGroupData: {
            acquirer: components["schemas"]["Acquirer"];
            adjustments: components["schemas"]["SettlementAdjustmentSummaryData"][];
        };
        /** SettlementAdjustmentData */
        SettlementAdjustmentData: {
            amount: string;
            comment: string | null;
            name: string;
            transaction_type: components["schemas"]["AcquirerReconciliationTransactionType"];
            type: components["schemas"]["AdjustmentType"];
        };
        /** SettlementAdjustmentSummaryData */
        SettlementAdjustmentSummaryData: {
            display_name: string;
            total_amount: string;
        };
        /** SettlementSummaryData */
        SettlementSummaryData: {
            acquirer: string;
            adjustments: components["schemas"]["SettlementAdjustmentData"][];
            chargeback_amount: string;
            chargeback_fee: string;
            id: number;
            max_transaction_date: string;
            merchants: components["schemas"]["SettlementSummaryMerchantData"][];
            min_transaction_date: string;
            settlement_amount: string;
            /** Format: date */
            statement_date: string;
            statement_id: string;
        };
        /** SettlementSummaryMerchantData */
        SettlementSummaryMerchantData: {
            adjustments: components["schemas"]["SettlementAdjustmentData"][];
            merchant_id: string;
            settlement_amount: string;
        };
        /** ShowTransactionResponse */
        ShowTransactionResponse: {
            account: components["schemas"]["AccountBackofficeViewModel"] & {
                meta: {
                    blockLevels: unknown[];
                };
            };
            acquirer: string | null;
            amount: string;
            cancelled_by: string | null;
            /** Format: date-time */
            createdAt: string;
            external_id: string | null;
            fee: string;
            id: string;
            meta: {
                [key: string]: unknown;
            };
            pspStatusCode: string | null;
            scaMode: components["schemas"]["ScaMode"] | null;
            scaStatus: components["schemas"]["ScaStatus"] | null;
            state: string;
            stateLog: components["schemas"]["StateLogViewModel"][];
            /** Format: date-time */
            stateSetAt: string;
            statusCode: string | null;
            /** Format: date-time */
            updatedAt: string;
        };
        /** StateLogViewModel */
        StateLogViewModel: {
            /** Format: date-time */
            createdAt: string;
            previousState: string | null;
            reason: string;
            updatedState: string;
        };
        /** StuckRequest */
        StuckRequest: {
            /** Format: date-time */
            created_before: string;
            psp: components["schemas"]["PSP"];
        };
        /** StuckWithdrawalsResponse */
        StuckWithdrawalsResponse: {
            withdrawals: string;
        };
        /** SuccessfulCountForUsersRequest */
        SuccessfulCountForUsersRequest: {
            brand?: components["schemas"]["Brand"] | null;
            userIds: number[];
        };
        /** SuccessfulCountForUsersViewModel */
        SuccessfulCountForUsersViewModel: {
            count: number;
            sum: number;
            user_id: number;
        };
        /** SuccessfulDepositCountRequest */
        SuccessfulDepositCountRequest: {
            brand?: components["schemas"]["Brand"] | null;
        };
        /** SuccessfulDepositCountResponse */
        SuccessfulDepositCountResponse: {
            count: number;
        };
        /** SuccessfulDepositsInterval */
        SuccessfulDepositsInterval: {
            /** Format: date-time */
            from: string;
            key: string;
            /** Format: date-time */
            to: string;
        };
        /** SummaryOverviewEntry */
        SummaryOverviewEntry: {
            payment_method: string;
            psp: string;
            total_amount: string;
            total_count: number;
        };
        /** SummaryOverviewRequest */
        SummaryOverviewRequest: {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
        };
        /** SummaryOverviewResponse */
        SummaryOverviewResponse: {
            data: components["schemas"]["SummaryOverviewEntry"][];
        };
        /** SumTransactionRequest */
        SumTransactionRequest: {
            userId: string;
        };
        /** ToggleIgnoredByClosedLoopRequest */
        ToggleIgnoredByClosedLoopRequest: {
            reason: string;
        };
        /** ToggleIgnoredByClosedLoopResponse */
        ToggleIgnoredByClosedLoopResponse: {
            success: boolean;
        };
        /** ToggleIgnoredClosedLoopRequest */
        ToggleIgnoredClosedLoopRequest: {
            changedBy: string;
            reason: string;
        };
        /** TopListIndexRequest */
        TopListIndexRequest: {
            /** Format: date-time */
            from: string;
            limit: number;
            order: components["schemas"]["TopListOrder"];
            /** Format: date-time */
            to: string;
            type: components["schemas"]["TopListType"];
        };
        /** TopListIndexResponse */
        TopListIndexResponse: {
            data: components["schemas"]["TopListIndexViewModel"][];
            headers: string[];
        };
        /** TopListIndexViewModel */
        TopListIndexViewModel: {
            count: number;
            sum: string;
            userId: number;
            wageredAmount: string;
        };
        /** TopListOption */
        TopListOption: {
            name: string;
            value: string;
        };
        /**
         * TopListOrder
         * @enum {string}
         */
        TopListOrder: TopListOrder;
        /** TopListSearchOptionsResponse */
        TopListSearchOptionsResponse: {
            order: components["schemas"]["TopListOption"][];
            type: components["schemas"]["TopListOption"][];
        };
        /**
         * TopListType
         * @enum {string}
         */
        TopListType: TopListType;
        /** TransactionAmountLimits */
        TransactionAmountLimits: {
            max: string;
            min: string;
        };
        /** TransactionsControllerDetailsRequest */
        TransactionsControllerDetailsRequest: {
            type: components["schemas"]["TransactionType"];
        };
        /**
         * TransactionsControllerDetailsResponse
         * @description Response data for the transaction details view in the support backoffice
         */
        TransactionsControllerDetailsResponse: {
            transaction: string;
        };
        /** TransactionsOverview */
        TransactionsOverview: {
            count: number;
            max: string;
            min: string;
            sum: string;
        };
        /** TransactionsOverviewModel */
        TransactionsOverviewModel: {
            deposits: components["schemas"]["TransactionsOverview"];
            key: string;
            withdrawals: components["schemas"]["TransactionsOverview"];
        };
        /** TransactionsOverviewRequest */
        TransactionsOverviewRequest: {
            accountId?: string | null;
            intervals: components["schemas"]["SuccessfulDepositsInterval"][];
            playerId: string;
        };
        /** TransactionsOverviewResponse */
        TransactionsOverviewResponse: {
            data: components["schemas"]["TransactionsOverviewModel"][];
        };
        /** TransactionsRequest */
        TransactionsRequest: {
            accountId: string;
            /** Format: date-time */
            from?: string | null;
            playerId: string;
            /** Format: date-time */
            to?: string | null;
        };
        /** TransactionsResponse */
        TransactionsResponse: {
            data: components["schemas"]["TransactionViewModel"][];
        };
        /**
         * TransactionState
         * @enum {string}
         */
        TransactionState: TransactionState;
        /**
         * TransactionType
         * @enum {string}
         */
        TransactionType: TransactionType;
        /** TransactionViewModel */
        TransactionViewModel: {
            data: string;
            type: components["schemas"]["TransactionType"];
        };
        /** UnreconciledEntryData */
        UnreconciledEntryData: {
            acquirer: components["schemas"]["Acquirer"] | null;
            acquirer_amount: string | null;
            acquirer_reconciliation_id: number | null;
            /** Format: date-time */
            date: string;
            external_id: string | null;
            our_amount: string | null;
            source: components["schemas"]["UnreconciledEntrySource"];
            state: string | null;
            transaction_id: string | null;
            transaction_type: components["schemas"]["AcquirerReconciliationTransactionType"] | null;
        };
        /**
         * UnreconciledEntrySource
         * @enum {string}
         */
        UnreconciledEntrySource: UnreconciledEntrySource;
        /** UpdatableAccountData */
        UpdatableAccountData: {
            established?: boolean | null;
            /** Format: date-time */
            expiryDate?: string | null;
            holderName?: string | null;
            isVisible?: boolean | null;
            pspUniqueReferenceId?: string | null;
            publicIdentifier?: string | null;
            replacementId?: string | null;
        };
        /** UpdatableDepositData */
        UpdatableDepositData: {
            acquirer?: components["schemas"]["Acquirer"] | null;
            scaStatus: components["schemas"]["ScaStatus"];
        };
        /** UpdatableRefundData */
        UpdatableRefundData: {
            acquirer?: components["schemas"]["Acquirer"] | null;
        };
        /** UpdatableWithdrawalData */
        UpdatableWithdrawalData: {
            acquirer?: components["schemas"]["Acquirer"] | null;
            externalId?: string | null;
        };
        /** UploadFinanceDocumentRequest */
        UploadFinanceDocumentRequest: {
            category?: string | null;
            /** Format: binary */
            file: string;
            key?: string | null;
        };
        /** UserActivityIndexRequest */
        UserActivityIndexRequest: {
            lookback: string;
            /** @default 1 */
            page?: number;
            /** @default 10 */
            perPage?: number;
        };
        /** UserActivityIndexResponse */
        UserActivityIndexResponse: {
            current_page: number;
            data: components["schemas"]["UserActivityRow"][];
            last_page: number;
            per_page: number;
            total: number;
        };
        /** UserActivityRow */
        UserActivityRow: {
            amount: string;
            /** Format: date-time */
            created_at: string;
            description: string;
            fee: string;
            net_amount: string;
        };
        /** UserData */
        UserData: {
            email: string | null;
        };
        /** UserDepositStatsControllerIndexResponse */
        UserDepositStatsControllerIndexResponse: {
            number: number;
            sum: string;
        };
        /** UserDepositStatsControllerSuccessfulCountForUsersResponse */
        UserDepositStatsControllerSuccessfulCountForUsersResponse: {
            data: components["schemas"]["SuccessfulCountForUsersViewModel"][];
        };
        /** UserDepositStatsControllerUsersWithFirstDepositsResponse */
        UserDepositStatsControllerUsersWithFirstDepositsResponse: {
            data: components["schemas"]["UsersWithFirstDepositsViewModel"][];
        };
        /** UserInfo */
        UserInfo: {
            address?: string | null;
            birthdate?: string | null;
            city?: string | null;
            countryCode?: string | null;
            email: string;
            ip?: string | null;
            name: string;
            phone?: string | null;
            phoneCountryCode?: string | null;
            zipcode?: string | null;
        };
        /** UserInfoExtended */
        UserInfoExtended: {
            address: string | null;
            birthdate: string | null;
            city: string | null;
            countryCode: string | null;
            email: string;
            ip: string | null;
            name: string;
            phone: string | null;
            phoneCountryCode: string | null;
            sex: string;
            ssn: string;
            userValidationStatus: components["schemas"]["UserValidationStatus"];
            zipcode: string | null;
        };
        /** UsersWithFirstDepositsRequest */
        UsersWithFirstDepositsRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** UsersWithFirstDepositsViewModel */
        UsersWithFirstDepositsViewModel: {
            /** Format: date-time */
            created_at: string;
            user_id: number;
        };
        /**
         * UserValidationStatus
         * @enum {integer}
         */
        UserValidationStatus: UserValidationStatus;
        /** UserWithdrawalCancelInfoResponse */
        UserWithdrawalCancelInfoResponse: {
            amount: number;
            count: number;
        };
        /** UserWithdrawalRecentResponse */
        UserWithdrawalRecentResponse: {
            cancellable: boolean;
            normalStateFlow: string[];
            withdrawals: components["schemas"]["UserWithdrawalRecentWithdrawal"][];
        };
        /** UserWithdrawalRecentWithdrawal */
        UserWithdrawalRecentWithdrawal: {
            amount: number;
            brand: components["schemas"]["Brand"];
            cancellable: boolean;
            cancelled_by: components["schemas"]["WithdrawalCancelledBy"];
            estimated_withdrawal_time: string | null;
            fee: number;
            id: string;
            paid_out_amount: number;
            payment_method: string;
            public_identifier: string | null;
            state_logs: components["schemas"]["WithdrawalStateLogData"][];
        };
        /** UuidV7 */
        UuidV7: string;
        /** VerifyUserRequest */
        VerifyUserRequest: Record<string, never>;
        /** VerifyUserResponse */
        VerifyUserResponse: {
            reason: string | null;
            userFlags: string[];
            userInfo: components["schemas"]["UserInfoExtended"];
            verified: boolean;
        };
        /**
         * WebContainer
         * @enum {string}
         */
        WebContainer: WebContainer;
        /**
         * WebMethod
         * @enum {string}
         */
        WebMethod: WebMethod;
        /** Withdrawal */
        Withdrawal: {
            account: components["schemas"]["Account"];
            account_id: string;
            acquirer?: components["schemas"]["Acquirer"] | null;
            amount: string;
            brand: components["schemas"]["Brand"];
            cancelled_by: components["schemas"]["WithdrawalCancelledBy"];
            /** Format: date-time */
            created_at: string;
            created_by: components["schemas"]["WithdrawalCreatedBy"];
            external_id?: string | null;
            fee: string;
            id: string;
            state: components["schemas"]["WithdrawalState"];
            /** Format: date-time */
            updated_at: string;
        };
        /** WithdrawalAccountsResponse */
        WithdrawalAccountsResponse: {
            accounts: components["schemas"]["CashierAccount"][];
        };
        /**
         * WithdrawalCancelledBy
         * @enum {string}
         */
        WithdrawalCancelledBy: WithdrawalCancelledBy;
        /** WithdrawalCancelStatusRequest */
        WithdrawalCancelStatusRequest: {
            withdrawals: string[];
        };
        /** WithdrawalCancelStatusResponse */
        WithdrawalCancelStatusResponse: {
            cancelStatuses: {
                [key: string]: boolean;
            };
        };
        /**
         * WithdrawalCreatedBy
         * @enum {string}
         */
        WithdrawalCreatedBy: WithdrawalCreatedBy;
        /** WithdrawalReceipt */
        WithdrawalReceipt: {
            account: components["schemas"]["CashierAccount"];
            amount: string;
            /** Format: date-time */
            createdAt: string;
            fee: string;
            transactionId: string;
        };
        /** WithdrawalReceiptRequest */
        WithdrawalReceiptRequest: {
            provider: components["schemas"]["PSP"];
            providerTransactionId: string;
        };
        /** WithdrawalReceiptResponse */
        WithdrawalReceiptResponse: {
            receipt: components["schemas"]["WithdrawalReceipt"];
            state: components["schemas"]["TransactionState"];
        };
        /** WithdrawalsControllerIndexRequest */
        WithdrawalsControllerIndexRequest: {
            /** Format: date-time */
            from?: string | null;
            /** @default 1 */
            page?: number;
            perPage?: number | null;
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * WithdrawalState
         * @enum {string}
         */
        WithdrawalState: WithdrawalState;
        /** WithdrawalStateLogData */
        WithdrawalStateLogData: {
            created_at: string;
            state: components["schemas"]["App.Enums.States.WithdrawalState"];
        };
        /** WithdrawalUserDetails */
        WithdrawalUserDetails: {
            isNewUser: boolean;
            isStaff: boolean;
            jackpotStats: components["schemas"]["JackpotStats"];
            reasonsForManualApproval: string[];
            recentlyUsedAccountsCount: number;
            spendFactor: string | null;
            totalDepositsCount: number;
            totalDepositsSum: string;
            totalUserAccounts: number;
            totalWithdrawalsCount: number;
            totalWithdrawalsSum: string;
            userId: string;
        };
        /** WithdrawalViewData */
        WithdrawalViewData: {
            count: number;
            /** Format: date-time */
            created_at: string;
            fees: string;
            sum: string;
            user_id: number;
        };
    };
    responses: {
        /** @description Authorization error */
        AuthorizationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Not found */
        NotFoundHttpException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[];
                    };
                    /** @description Errors overview. */
                    message: string;
                };
            };
        };
    };
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "backoffice.account.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `Modules.Backoffice.Http.Requests.IndexRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Modules.Backoffice.Http.Requests.IndexRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        headers: [
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ],
                            [
                                "id",
                                "user_id",
                                "player_id",
                                "country_code",
                                "created_at",
                                "is_visible",
                                "established",
                                "psp",
                                "payment_method",
                                "public_identifier",
                                "psp_unique_reference_id",
                                "holder_name",
                                "issuer",
                                "sca_status",
                                "block",
                                "expires_at",
                                "first_success",
                                "last_success",
                                "last_attempt",
                                "ignored_by_closed_loop"
                            ]
                        ];
                        paginator: components["schemas"]["Paginator"];
                        searchOptions: {
                            block: {
                                [key: string]: string;
                            };
                            established: [
                                [
                                    "true",
                                    "false"
                                ],
                                [
                                    "true",
                                    "false"
                                ]
                            ];
                            ignored_by_closed_loop: [
                                [
                                    "true",
                                    "false"
                                ],
                                [
                                    "true",
                                    "false"
                                ]
                            ];
                            is_visible: [
                                [
                                    "true",
                                    "false"
                                ],
                                [
                                    "true",
                                    "false"
                                ]
                            ];
                            payment_method: {
                                [key: string]: string;
                            };
                            psp: {
                                [key: string]: string;
                            };
                            sca_status: {
                                [key: string]: string;
                            };
                        };
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.account.closed-loop.toggle": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `ToggleIgnoredByClosedLoopRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ToggleIgnoredByClosedLoopRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.account.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountBackofficeViewModel` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["AccountBackofficeViewModel"];
                        meta: {
                            blockLevels: unknown[];
                        };
                    };
                };
            };
        };
    };
    "backoffice.account.block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BlockAccountsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BlockAccountsRequest"];
            };
        };
        responses: {
            /** @description `BlockAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BlockAccountsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.approval.approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ApproveRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.approval.deny": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DenyRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DenyRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.approval.user-details": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `WithdrawalUserDetails` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WithdrawalUserDetails"];
                };
            };
        };
    };
    "backoffice.approval.withdrawals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `NeedApprovalWithdrawalIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NeedApprovalWithdrawalIndexResponse"];
                };
            };
        };
    };
    "modules.backoffice.credorax.getArn_142": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetArnRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetArnRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.dynamic-config.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "backoffice.dynamic-config.structure": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                namespace: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        description: string;
                        fields: Record<string, never>;
                        namespace: string;
                    };
                };
            };
        };
    };
    "backoffice.dynamic-config.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                namespace: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        success: boolean;
                    } | {
                        errors: string;
                        message: string;
                        success: boolean;
                    };
                };
            };
        };
    };
    "backoffice.dynamic-config.import-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DynamicConfigImportConfigResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DynamicConfigImportConfigResponse"];
                };
            };
        };
    };
    "backoffice.dynamic-config.reset-and-implement-config": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                configType: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Database has been reset and config data implemented successfully.";
                    };
                };
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Configuration reset is not allowed in the current environment.";
                    };
                };
            };
        };
    };
    "platform.chargeback-cases.index": {
        parameters: {
            query?: {
                outstandingOnly?: boolean;
                page?: number;
                perPage?: number;
                playerId?: string | null;
                userId?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ListChargebackCasesResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListChargebackCasesResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.chargeback-cases.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ChargebackCaseData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChargebackCaseData"];
                };
            };
        };
    };
    "platform.chargeback-cases.export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Transfer-Encoding": PathsBackofficeFinanceAutomationChargebackCasesExportGetResponses200HeadersTransferEncoding;
                    [name: string]: unknown;
                };
                content: {
                    "text/csv; charset=UTF-8": string;
                };
            };
        };
    };
    "platform.chargeback-repayments.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateChargebackRepaymentRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateChargebackRepaymentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.chargeback-repayments.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ChargebackRepaymentData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChargebackRepaymentData"];
                };
            };
        };
    };
    "platform.chargebacks.index": {
        parameters: {
            query?: {
                filters?: {
                    [key: string]: string;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ModelSearchResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModelSearchResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.chargebacks.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ChargebackData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChargebackData"];
                };
            };
        };
    };
    "platform.chargebacks.search-parameters": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        name: string;
                        nullable: boolean;
                        options: string[];
                        type: string;
                    }[];
                };
            };
        };
    };
    "platform.credorax.chargebacks.fetch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CredoraxChargebackData"][];
                };
            };
        };
    };
    "platform.documents.list": {
        parameters: {
            query?: {
                category?: string | null;
                page?: number | null;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ListFinanceDocumentsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListFinanceDocumentsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.documents.upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UploadFinanceDocumentRequest` */
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["UploadFinanceDocumentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: unknown[];
                        message: string;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.documents.delete": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "platform.documents.download": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "platform.reconciliations.unreconciled": {
        parameters: {
            query: {
                acquirers?: components["schemas"]["Acquirer"][] | null;
                from_date: string;
                page?: number | null;
                per_page?: number | null;
                to_date: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ListUnreconciledTransactionsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListUnreconciledTransactionsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.settlement-adjustments.monthly": {
        parameters: {
            query: {
                acquirers?: components["schemas"]["Acquirer"][] | null;
                month: number;
                year: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ListMonthlySettlementAdjustmentsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListMonthlySettlementAdjustmentsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.settlement-summaries.index": {
        parameters: {
            query?: {
                page?: number | null;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ListSettlementSummariesResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListSettlementSummariesResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.settlement-summaries.recalculate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RecalculateSettlementSummaryRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RecalculateSettlementSummaryRequest"];
            };
        };
        responses: {
            /** @description `RecalculateSettlementSummaryResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RecalculateSettlementSummaryResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.top-list.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `TopListIndexRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["TopListIndexRequest"];
            };
        };
        responses: {
            /** @description `TopListIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TopListIndexResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.top-list.search-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `TopListSearchOptionsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TopListSearchOptionsResponse"];
                };
            };
        };
    };
    "backoffice.transaction.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `Modules.Backoffice.Http.Requests.IndexRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Modules.Backoffice.Http.Requests.IndexRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        headers: [
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ],
                            [
                                "id",
                                "external_id",
                                "acquirer",
                                "user_id",
                                "player_id",
                                "account_id",
                                "type",
                                "state",
                                "amount",
                                "fee",
                                "psp",
                                "payment_method",
                                "holder_name",
                                "public_identifier",
                                "brand",
                                "status_code",
                                "sca_mode",
                                "created_at"
                            ]
                        ];
                        paginator: components["schemas"]["Paginator"];
                        searchOptions: {
                            acquirer: {
                                [key: string]: string;
                            };
                            brand: string;
                            payment_method: {
                                [key: string]: string;
                            };
                            psp: {
                                [key: string]: string;
                            };
                            sca_mode: {
                                [key: string]: string;
                            };
                            state: unknown[];
                            status_code: {
                                [key: string]: string;
                            };
                            type: {
                                [key: string]: string;
                            };
                        };
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.transaction.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                transactionType: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ShowTransactionResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ShowTransactionResponse"];
                };
            };
        };
    };
    "backoffice.transaction.payment-information": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                transactionType: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "backoffice.transaction.allowed-states": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetAllowedStatesRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetAllowedStatesRequest"];
            };
        };
        responses: {
            /** @description `GetAllowedStatesResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetAllowedStatesResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.transaction.force-state": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ForceStateRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ForceStateRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.transaction.mass-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `MassUpdateStateRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["MassUpdateStateRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        failed: string;
                        notFound: string[];
                        successful: string[];
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.transaction.sumTransactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SumTransactionRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SumTransactionRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        depositCount: number;
                        finalizedDepositSum: components["schemas"]["Decimal"];
                        finalizedWithdrawalSum: components["schemas"]["Decimal"];
                        withdrawalCount: number;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.transaction.summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SummaryOverviewRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SummaryOverviewRequest"];
            };
        };
        responses: {
            /** @description `SummaryOverviewResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SummaryOverviewResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.users.closed-loop-info": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userIdentifier: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ClosedLoopControllerIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClosedLoopControllerIndexResponse"];
                };
            };
        };
    };
    "backoffice.withdrawal.cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CancelWithdrawalsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CancelWithdrawalsRequest"];
            };
        };
        responses: {
            /** @description `CancelWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CancelWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backoffice.withdrawal.revert": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RevertWithdrawalsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RevertWithdrawalsRequest"];
            };
        };
        responses: {
            /** @description `RevertWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RevertWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "import.dynamic-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ReceiveDynamicConfigsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReceiveDynamicConfigsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            404: components["responses"]["NotFoundHttpException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.account.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `UpdatableAccountData` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdatableAccountData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.deposit.finalize": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The deposit ID */
                deposit: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `FinalizeDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinalizeDepositRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.deposit.reject": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The deposit ID */
                deposit: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `RejectRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RejectRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.deposit.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The deposit ID */
                deposit: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `UpdatableDepositData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdatableDepositData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        deposit: components["schemas"]["Deposit"];
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.deposit.authorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `AuthorizeDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["AuthorizeDepositRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderQuickDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderQuickDepositRequest"];
            };
        };
        responses: {
            /** @description `QuickDepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QuickDepositResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-first-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateFirstDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateFirstDepositRequest"];
            };
        };
        responses: {
            /** @description `FirstDepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FirstDepositResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.deposit.get-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DepositAttributesRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DepositAttributesRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.deposit.update-kyc-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetKycStatusRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetKycStatusRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.fraud.analysis.sca": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                paymentMethod: string;
                PSP: string;
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ScaAnalysis` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ScaAnalysis"];
                };
            };
        };
    };
    "paymentServiceControllerContract.getArn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetArnRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetArnRequest"];
            };
        };
        responses: {
            /** @description `GetArnResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetArnResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.get-payment-information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetPaymentInformationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetPaymentInformationRequest"];
            };
        };
        responses: {
            /** @description `GetPaymentInformationResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPaymentInformationResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.refund.authorize": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The refund ID */
                refund: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `AuthorizeRefundRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["AuthorizeRefundRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.refund.finalize": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The refund ID */
                refund: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `FinalizeRefundRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinalizeRefundRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.refund.reject": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The refund ID */
                refund: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `RejectRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RejectRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-refund": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderRefundRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderRefundRequest"];
            };
        };
        responses: {
            /** @description `CreateRefundResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateRefundResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.user.verify": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: string;
            };
            cookie?: never;
        };
        /** @description `VerifyUserRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["VerifyUserRequest"];
            };
        };
        responses: {
            /** @description `VerifyUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VerifyUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.withdraw.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The withdrawal ID */
                withdrawal: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "integration.withdraw.finalize": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The withdrawal ID */
                withdrawal: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `FinalizeWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinalizeWithdrawalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.withdraw.reject": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The withdrawal ID */
                withdrawal: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `RejectRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RejectRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "integration.withdraw.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The withdrawal ID */
                withdrawal: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `UpdatableWithdrawalData` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdatableWithdrawalData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.approve-withdrawal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ApproveWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveWithdrawalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.cancel-withdrawal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CancelWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CancelWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `CancelWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CancelWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.withdrawals.cancel-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `WithdrawalCancelStatusRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["WithdrawalCancelStatusRequest"];
            };
        };
        responses: {
            /** @description `WithdrawalCancelStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WithdrawalCancelStatusResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-withdrawal.cit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `CreateWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-withdrawal.cit-open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `CreateWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-withdrawal.mit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `CreateWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.create-withdrawal.mit-open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateProviderWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProviderWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `CreateWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.deny-withdrawal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DenyWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DenyWithdrawalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "payment-service.revert-withdrawal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RevertWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RevertWithdrawalRequest"];
            };
        };
        responses: {
            /** @description `RevertWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RevertWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.block-account": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `BlockAccountRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BlockAccountRequest"];
            };
        };
        responses: {
            /** @description `BlockAccountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BlockAccountResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.toggle-closed-loop-for-account": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `ToggleIgnoredClosedLoopRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ToggleIgnoredClosedLoopRequest"];
            };
        };
        responses: {
            /** @description `ToggleIgnoredByClosedLoopResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ToggleIgnoredByClosedLoopResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.block-accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BlockAccountsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BlockAccountsRequest"];
            };
        };
        responses: {
            /** @description `BlockAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BlockAccountsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.combined-accounts-overview": {
        parameters: {
            query: {
                playerId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `CombinedAccountOverviewResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CombinedAccountOverviewResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.deposit-stats": {
        parameters: {
            query: {
                from?: string | null;
                playerId: string;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositStatsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositStatsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.payments-overview": {
        parameters: {
            query: {
                from?: string | null;
                playerId: string;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `BalanceOverviewResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BalanceOverviewResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.transactionsByPlayer": {
        parameters: {
            query: {
                from?: string | null;
                playerId: string;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `PlayerTransactionsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerTransactionsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.transactions": {
        parameters: {
            query: {
                accountId: string;
                from?: string | null;
                playerId: string;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `TransactionsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransactionsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.transactions-overview": {
        parameters: {
            query: {
                accountId?: string | null;
                intervals: components["schemas"]["SuccessfulDepositsInterval"][];
                playerId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `TransactionsOverviewResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransactionsOverviewResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.refund": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The deposit ID */
                deposit: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `CreateRefundRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateRefundRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string | {
                        refund: components["schemas"]["Refund"];
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.manual-transaction.create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateManualTransactionRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateManualTransactionRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.money-limits.deposit-limit-progress": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": [
                        [
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"]
                        ],
                        [
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"]
                        ],
                        [
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"],
                            components["schemas"]["Decimal"]
                        ]
                    ];
                };
            };
        };
    };
    "platform.monolith-backoffice.accounts.hide": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "platform.monolith-backoffice.accounts": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountsControllerIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountsControllerIndexResponse"];
                };
            };
        };
    };
    "platform.monolith-backoffice.mit-withdrawable-accounts": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountsControllerMitWithdrawableAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountsControllerMitWithdrawableAccountsResponse"];
                };
            };
        };
    };
    "platform.monolith-backoffice.payment-details": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                uuid: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `PaymentsControllerDetailsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentsControllerDetailsResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "platform.monolith-backoffice.payments": {
        parameters: {
            query?: {
                from?: string | null;
                page?: number;
                perPage?: number | null;
                to?: string | null;
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Transfer-Encoding": PathsPlatformMonolithBackofficePaymentsUserIdGetResponses200HeadersTransferEncoding;
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        count: number;
                        page: number;
                        payments: Record<string, never>;
                        per_page: number | null;
                        sum: components["schemas"]["Decimal"];
                        sumForAllUsers: components["schemas"]["Decimal"];
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.monolith-backoffice.payouts": {
        parameters: {
            query?: {
                from?: string | null;
                page?: number;
                perPage?: number | null;
                to?: string | null;
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Transfer-Encoding": PathsPlatformMonolithBackofficePayoutsUserIdGetResponses200HeadersTransferEncoding;
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        count: number;
                        page: number;
                        payouts: Record<string, never>;
                        per_page: number | null;
                        sum: components["schemas"]["Decimal"];
                        sumForAllUsers: components["schemas"]["Decimal"];
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.accounts.players.accounts-used-count": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountCountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountCountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.accounts.players.established": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `EstablishedForPlayerResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EstablishedForPlayerResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.accounts.players.has-recent-success-with-different-method": {
        parameters: {
            query: {
                from?: string | null;
                paymentMethod: components["schemas"]["PaymentMethod"];
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasRecentSuccessWithDifferentPaymentMethodResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasRecentSuccessWithDifferentPaymentMethodResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.accounts.players.recent-success": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountsWithRecentSuccessResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountsWithRecentSuccessResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.player.deposit-stats": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `SuccessfulDepositCountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SuccessfulDepositCountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.active-amount-since": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AmountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AmountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.finalized-amount": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AmountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AmountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.has-finalized": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasFinalizedResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasFinalizedResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.has-since": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasSinceResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasSinceResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.max-amount": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AmountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AmountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.deposits.players.payment-method-amount": {
        parameters: {
            query: {
                from?: string | null;
                paymentMethod: components["schemas"]["PaymentMethod"];
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AmountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AmountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.manual-transactions.players.amount-for-type": {
        parameters: {
            query: {
                from?: string | null;
                to?: string | null;
                type: components["schemas"]["ManualTransactionType"];
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `PositiveTypeSumResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PositiveTypeSumResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.players.has-since": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `App.Http.Responses.PlatformApi.WithdrawalController.HasSinceResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["App.Http.Responses.PlatformApi.WithdrawalController.HasSinceResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "case-management.players.manually-approved-withdrawals": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ManuallyApprovedWithdrawalForPlayerResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManuallyApprovedWithdrawalForPlayerResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.raven-track.metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RavenTrackMetricsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RavenTrackMetricsRequest"];
            };
        };
        responses: {
            /** @description `RavenTrackMetricsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RavenTrackMetricsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.accounts.hide": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "platform.support-backoffice.deposits.refund": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The deposit ID */
                deposit: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        /** @description `CreateRefundRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateRefundRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string | {
                        refund: components["schemas"]["Refund"];
                        success: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.transaction.get-arn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetArnRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetArnRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.transactions.details": {
        parameters: {
            query: {
                type: components["schemas"]["TransactionType"];
            };
            header?: never;
            path: {
                uuid: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `TransactionsControllerDetailsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransactionsControllerDetailsResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.user.accounts": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountsControllerIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountsControllerIndexResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "platform.support-backoffice.user.accounts.mit-withdrawable": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AccountsControllerMitWithdrawableAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountsControllerMitWithdrawableAccountsResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "platform.support-backoffice.user.deposits": {
        parameters: {
            query?: {
                from?: string | null;
                page?: number;
                perPage?: number | null;
                to?: string | null;
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Transfer-Encoding": PathsPlatformSupportBackofficeUserUserIdDepositsGetResponses200HeadersTransferEncoding;
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        count: number;
                        depositsAndRefunds: Record<string, never>;
                        page: number;
                        per_page: number | null;
                        sum: components["schemas"]["Decimal"];
                        sumForAllUsers: components["schemas"]["Decimal"];
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.user.manual-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `IndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IndexResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "platform.support-backoffice.user.withdrawals": {
        parameters: {
            query?: {
                from?: string | null;
                page?: number;
                perPage?: number | null;
                to?: string | null;
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Transfer-Encoding": PathsPlatformSupportBackofficeUserUserIdWithdrawalsGetResponses200HeadersTransferEncoding;
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        count: number;
                        page: number;
                        per_page: number | null;
                        sum: components["schemas"]["Decimal"];
                        sumForAllUsers: components["schemas"]["Decimal"];
                        withdrawals: Record<string, never>;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.withdrawals.closed-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateMitWithdrawalOnExistingAccountRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMitWithdrawalOnExistingAccountRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        success: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.support-backoffice.withdrawals.open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateMitWithdrawalOnNewAccountRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMitWithdrawalOnNewAccountRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        success: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.user.accounts.established": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `EstablishedForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EstablishedForUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.user.deposits.finalized": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `FinalizedForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FinalizedForUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.user.deposits.has-user-made-a-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasUserMadeADepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasUserMadeADepositResponse"];
                };
            };
        };
    };
    "platform.user.deposits.last-successful-deposit": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
            };
            header?: never;
            path: {
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `LastSuccessfulForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LastSuccessfulForUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.user.deposits.last-successful-time": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `LastSuccessfulDepositTimeResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LastSuccessfulDepositTimeResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.user.manual-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `IndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IndexResponse"];
                };
            };
        };
    };
    "platform.user.withdrawals.finalized": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `App.Http.Responses.PlatformApi.WithdrawalController.FinalizedForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["App.Http.Responses.PlatformApi.WithdrawalController.FinalizedForUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.users.deposits.first-depositing-users": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserDepositStatsControllerUsersWithFirstDepositsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserDepositStatsControllerUsersWithFirstDepositsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.users.deposits.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `IndexRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["IndexRequest"];
            };
        };
        responses: {
            /** @description `UserDepositStatsControllerIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserDepositStatsControllerIndexResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.users.deposits.successful-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SuccessfulCountForUsersRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SuccessfulCountForUsersRequest"];
            };
        };
        responses: {
            /** @description `UserDepositStatsControllerSuccessfulCountForUsersResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserDepositStatsControllerSuccessfulCountForUsersResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateMitWithdrawalOnExistingAccountRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMitWithdrawalOnExistingAccountRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        success: string;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.attempt-automatic": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `AutomaticWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["AutomaticWithdrawalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        attemptPossible: boolean;
                        /** @constant */
                        message: "Automatic withdrawal attempt failed";
                    } | {
                        attemptPossible: boolean;
                        /** @constant */
                        message: "Automatic withdrawal attempt successfully initiated";
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.monolith.withdrawals.find-by-ids": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `FindByIdsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FindByIdsRequest"];
            };
        };
        responses: {
            /** @description `FindByIdsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FindByIdsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.minimum-withdrawable-amount": {
        parameters: {
            query: {
                userId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        fee: number;
                        minimumAmount: number;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.monolith.withdrawals.non-failed-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `NonFailedStatsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NonFailedStatsRequest"];
            };
        };
        responses: {
            /** @description `NonFailedStatsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NonFailedStatsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateMitWithdrawalOnNewAccountRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMitWithdrawalOnNewAccountRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        success: string;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "platform.withdrawals.stuck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `StuckRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StuckRequest"];
            };
        };
        responses: {
            /** @description `StuckWithdrawalsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StuckWithdrawalsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.certificate": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                brand: string;
                paymentMethod: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string | PathsPublicPaymentMethodCertificateBrandGetResponses200ContentApplicationJsonAnyOf1;
                };
            };
        };
    };
    "public.account.account.disable": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account ID */
                account: components["schemas"]["UuidV7"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `MessageResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MessageResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "public.cashier.deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `QuickDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["QuickDepositRequest"];
            };
        };
        responses: {
            /** @description `App.Http.Responses.PublicApi.DepositCashierController.QuickDepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QuickDepositResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositAccountsResponse"];
                };
            };
        };
    };
    "public.cashier.deposit.calculate-fee": {
        parameters: {
            query: {
                amount: string;
                isBonusToggled?: string;
                paymentMethod: components["schemas"]["PaymentMethod"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `CalculateFeeResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CalculateFeeResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.configs": {
        parameters: {
            query: {
                brand: components["schemas"]["Brand"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositConfigResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositConfigResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DepositOptionsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DepositOptionsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @description Error overview. */
                        message: string;
                    };
                };
            };
        };
    };
    "public.cashier.deposit.failed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `FailedDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FailedDepositRequest"];
            };
        };
        responses: {
            /** @description `FailedDepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FailedDepositResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.first-deposit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `FirstDepositRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FirstDepositRequest"];
            };
        };
        responses: {
            /** @description `FirstDepositResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FirstDepositResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.payment-methods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `PaymentMethodOptionsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentMethodOptionsResponse"];
                };
            };
        };
    };
    "public.cashier.deposit.receipt": {
        parameters: {
            query: {
                provider: components["schemas"]["PSP"];
                providerTransactionId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositReceipt` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositReceipt"];
                };
            };
            404: components["responses"]["NotFoundHttpException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.set-request-cache": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DepositRequestCacheRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DepositRequestCacheRequest"];
            };
        };
        responses: {
            /** @description `SetDepositRequestCacheResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetDepositRequestCacheResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.get-request-cache": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositRequestCacheResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositRequestCacheResponse"];
                };
            };
            404: components["responses"]["NotFoundHttpException"];
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @description Error overview. */
                        message: string;
                    };
                };
            };
        };
    };
    "public.cashier.deposit.status": {
        parameters: {
            query: {
                provider: components["schemas"]["PSP"];
                providerTransactionId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DepositStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositStatusResponse"];
                };
            };
            404: components["responses"]["NotFoundHttpException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.deposit.successful-count": {
        parameters: {
            query: {
                brand: components["schemas"]["Brand"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `App.Http.Responses.PublicApi.DepositCashierController.SuccessfulDepositCountResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["App.Http.Responses.PublicApi.DepositCashierController.SuccessfulDepositCountResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateWithdrawalData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateWithdrawalData"];
            };
        };
        responses: {
            /** @description `CreateCitWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateCitWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.withdraw.accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `WithdrawalAccountsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WithdrawalAccountsResponse"];
                };
            };
        };
    };
    "public.cashier.withdraw.calculate-withdrawal-limits-and-fee": {
        parameters: {
            query: {
                amount: string;
                paymentMethod: components["schemas"]["PaymentMethod"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        fee: number;
                        maximumWithdrawalLimit: number | string;
                        minimumWithdrawalLimit: number | string;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.withdraw.cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `App.Http.Requests.PublicApi.WithdrawalCashierController.CancelWithdrawalRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["App.Http.Requests.PublicApi.WithdrawalCashierController.CancelWithdrawalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.withdraw.cancel-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        withdrawalCount: number;
                    };
                };
            };
        };
    };
    "public.cashier.withdraw.open-loop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CreateOpenLoopWithdrawalData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOpenLoopWithdrawalData"];
            };
        };
        responses: {
            /** @description `CreateCitWithdrawalResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateCitWithdrawalResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.cashier.withdraw.receipt": {
        parameters: {
            query: {
                provider: components["schemas"]["PSP"];
                providerTransactionId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `WithdrawalReceiptResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WithdrawalReceiptResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.transactions.activity": {
        parameters: {
            query: {
                lookback: string;
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserActivityIndexResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserActivityIndexResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.withdrawals.cancel-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserWithdrawalCancelInfoResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserWithdrawalCancelInfoResponse"];
                };
            };
        };
    };
    "public.transactions.withdrawals.recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserWithdrawalRecentResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserWithdrawalRecentResponse"];
                };
            };
        };
    };
}
export enum PathsBackofficeFinanceAutomationChargebackCasesExportGetResponses200HeadersTransferEncoding {
    chunked = "chunked"
}
export enum PathsPlatformMonolithBackofficePaymentsUserIdGetResponses200HeadersTransferEncoding {
    chunked = "chunked"
}
export enum PathsPlatformMonolithBackofficePayoutsUserIdGetResponses200HeadersTransferEncoding {
    chunked = "chunked"
}
export enum PathsPlatformSupportBackofficeUserUserIdDepositsGetResponses200HeadersTransferEncoding {
    chunked = "chunked"
}
export enum PathsPlatformSupportBackofficeUserUserIdWithdrawalsGetResponses200HeadersTransferEncoding {
    chunked = "chunked"
}
export enum PathsPublicPaymentMethodCertificateBrandGetResponses200ContentApplicationJsonAnyOf1 {
    Empty = ""
}
export enum Acquirer {
    EPay = "EPay",
    BamboraGa = "BamboraGa",
    Credorax = "Credorax",
    Zimpler = "Zimpler",
    TrueLayer = "TrueLayer",
    PayPal = "PayPal",
    DummyAcquirer = "DummyAcquirer",
    NemKonto = "NemKonto",
    PBS = "PBS",
    Valitor = "Valitor",
    Nets = "Nets",
    Clearhaus = "Clearhaus",
    Worldline = "Worldline",
    Other = "Other"
}
export enum AcquirerReconciliationTransactionType {
    Deposit = "Deposit",
    Withdrawal = "Withdrawal",
    Refund = "Refund",
    Other = "Other"
}
export enum AdjustmentType {
    Fee = "Fee",
    Adjustment = "Adjustment"
}
export enum AppEnumsStatesDepositState {
    created = "created",
    authorized = "authorized",
    finalized = "finalized",
    rejected = "rejected",
    denied = "denied"
}
export enum AppEnumsStatesRefundState {
    created = "created",
    authorized = "authorized",
    finalized = "finalized",
    rejected = "rejected"
}
export enum AppEnumsStatesWithdrawalState {
    created = "created",
    needs_approval = "needs_approval",
    denied = "denied",
    approved = "approved",
    finalized = "finalized",
    rejected = "rejected"
}
export enum Brand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum CaptureMode {
    MANUAL = "MANUAL",
    AUTOMATIC = "AUTOMATIC"
}
export enum ChargebackEventType {
    Created = "Created",
    Reimbursed = "Reimbursed"
}
export enum Currency {
    DKK = "DKK",
    SEK = "SEK",
    GBP = "GBP",
    EUR = "EUR"
}
export enum DepositState {
    created = "created",
    authorized = "authorized",
    finalized = "finalized",
    rejected = "rejected",
    denied = "denied"
}
export enum FailedDepositReason {
    setup_failed = "setup_failed",
    psp_error = "psp_error",
    cancelled = "cancelled"
}
export enum FirstDepositType {
    ultimate = "ultimate",
    soft = "soft",
    returned = "returned"
}
export enum KycStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    PENDING = "PENDING"
}
export enum ManualTransactionType {
    DEPOSIT_MISSING_WINNINGS = "DEPOSIT_MISSING_WINNINGS",
    MARKETING_CAMPAIGN_WINNINGS = "MARKETING_CAMPAIGN_WINNINGS",
    AUTOMATIC_TRANSACTION_CORRECTION = "AUTOMATIC_TRANSACTION_CORRECTION",
    FAILED_GAME_INSTANCE_TRANSACTION = "FAILED_GAME_INSTANCE_TRANSACTION",
    OTHER = "OTHER",
    TRANSFER_OF_WINNINGS_AT_END_OF_BONUS = "TRANSFER_OF_WINNINGS_AT_END_OF_BONUS",
    SUPPORT_CORRECTION = "SUPPORT_CORRECTION",
    BANK_TRANSFER_TO_CUSTOMER = "BANK_TRANSFER_TO_CUSTOMER",
    TEST_TRANSACTION = "TEST_TRANSACTION",
    CHARGEBACK_REPAYMENT = "CHARGEBACK_REPAYMENT"
}
export enum PaymentMethod {
    CreditCard = "CreditCard",
    NemKonto = "NemKonto",
    Zimpler = "Zimpler",
    ApplePay = "ApplePay",
    GooglePay = "GooglePay",
    MobilePay = "MobilePay",
    TrueLayer = "TrueLayer",
    Paypal = "Paypal",
    DummyMethod = "DummyMethod"
}
export enum PaymentMethodBlock {
    NONE = "NONE",
    LOCAL = "LOCAL",
    GLOBAL = "GLOBAL"
}
export enum PaymentStatusCode {
    FRAUD = "FRAUD",
    SUCCESS = "SUCCESS",
    NO_FUNDS = "NO_FUNDS",
    REVERSED = "REVERSED",
    KYC_BLOCK = "KYC_BLOCK",
    BIN_BLOCK = "BIN_BLOCK",
    GUARD_BLOCK = "GUARD_BLOCK",
    SCA_FAILURE = "SCA_FAILURE",
    MISSING_SCA = "MISSING_SCA",
    BANK_REFUSAL = "BANK_REFUSAL",
    INVALID_INPUT = "INVALID_INPUT",
    GENERAL_ERROR = "GENERAL_ERROR",
    MISSING_INPUT = "MISSING_INPUT",
    VELOCITY_BLOCK = "VELOCITY_BLOCK",
    RESTRICTED_USER = "RESTRICTED_USER",
    LIMIT_OVERDRAWN = "LIMIT_OVERDRAWN",
    MONEY_LIMIT_BLOCK = "MONEY_LIMIT_BLOCK",
    CANCELLED_BY_USER = "CANCELLED_BY_USER",
    EXPIRED_PAYMENT_METHOD = "EXPIRED_PAYMENT_METHOD",
    SCA_REQUIRED_BY_ISSUER = "SCA_REQUIRED_BY_ISSUER",
    RESTRICTED_PAYMENT_METHOD = "RESTRICTED_PAYMENT_METHOD",
    ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
    CARD_BLOCKED = "CARD_BLOCKED",
    CARD_PIN_ISSUE = "CARD_PIN_ISSUE",
    ACQUIRER_ERROR = "ACQUIRER_ERROR",
    ISSUER_DOWN = "ISSUER_DOWN"
}
export enum PSP {
    PaymentIQ = "PaymentIQ",
    AltaPay = "AltaPay",
    NemKonto = "NemKonto",
    DummyPSP = "DummyPSP",
    ePay = "ePay",
    Legacy_ePay = "Legacy_ePay",
    Legacy_Pensio = "Legacy_Pensio",
    TrueLayer = "TrueLayer"
}
export enum RefundState {
    created = "created",
    authorized = "authorized",
    finalized = "finalized",
    rejected = "rejected"
}
export enum ScaMode {
    NORMAL = "NORMAL",
    CHALLENGE = "CHALLENGE",
    EXEMPTION = "EXEMPTION",
    SKIP = "SKIP"
}
export enum ScaStatus {
    UNKNOWN = "UNKNOWN",
    NOT_CHALLENGED = "NOT_CHALLENGED",
    FAILED = "FAILED",
    SUCCESS = "SUCCESS"
}
export enum TopListOrder {
    Sum_of = "Sum of",
    Number_of = "Number of"
}
export enum TopListType {
    App_Models_Deposit = "App\\Models\\Deposit",
    App_Models_Withdrawal = "App\\Models\\Withdrawal"
}
export enum TransactionState {
    SUCCESSFUL = "SUCCESSFUL",
    FAILED = "FAILED",
    PROCESSING = "PROCESSING"
}
export enum TransactionType {
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    REFUND = "REFUND"
}
export enum UnreconciledEntrySource {
    deposit_orphan = "deposit_orphan",
    withdrawal_orphan = "withdrawal_orphan",
    refund_orphan = "refund_orphan",
    acquirer_orphan = "acquirer_orphan",
    amount_mismatch = "amount_mismatch",
    state_mismatch = "state_mismatch"
}
export enum UserValidationStatus {
    Value1 = 1,
    Value2 = 2,
    Value3 = 3,
    Value4 = 4,
    Value5 = 5
}
export enum WebContainer {
    window = "window",
    iframe = "iframe"
}
export enum WebMethod {
    GET = "GET",
    POST = "POST"
}
export enum WithdrawalCancelledBy {
    NONE = "NONE",
    SYSTEM = "SYSTEM",
    ADMIN = "ADMIN",
    USER = "USER"
}
export enum WithdrawalCreatedBy {
    SYSTEM = "SYSTEM",
    ADMIN = "ADMIN",
    USER = "USER"
}
export enum WithdrawalState {
    created = "created",
    needs_approval = "needs_approval",
    denied = "denied",
    approved = "approved",
    finalized = "finalized",
    rejected = "rejected"
}
